<template>
  <v-data-table :headers="headers" :items="turmas" :sort-desc="true" class="elevation-1" :search="search">

    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-progress-circular :size="50" color="green" indeterminate v-if="isLoading"></v-progress-circular>
        <!-- <v-btn to="/menu-pautaTrimestral" class="mx-2" fab dark color="primary">
          <v-icon dark>arrow_back</v-icon>
        </v-btn> -->

        <v-divider class="mx-8" inset vertical></v-divider>
        <v-toolbar-title>
          Turma(s) da
          <span v-if="idclasse === 1">10ª classe</span>
          <span v-if="idclasse === 2">11ª classe</span>
          <span v-if="idclasse === 3">12ª classe</span>
          <span v-if="idclasse === 4">13ª classe</span>
        </v-toolbar-title>
        <v-divider class="mx-8" inset vertical></v-divider>
        <span>Selecionado : <strong style="font-size:22px;">{{ $store.state.novadescricaoSelecionado }}</strong></span>
        <!--  search  -->
        <div v-if="$store.state.hasMessage" :class="$store.state.classMessage">
          {{ $store.state.textMessage }}
        </div>

        <div class="flex-grow-1"></div>

        <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
        <!-- end  search  -->

        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="500px">

          <v-card>
            <v-card-title>
              <span v-if="idclasse === 1">10ª classe</span>
              <span v-if="idclasse === 2">11ª classe</span>
              <span v-if="idclasse === 3">12ª classe</span>
              <span v-if="idclasse === 4">13ª classe</span>
            </v-card-title>

          </v-card>
        </v-dialog>
        <div>
          <v-row justify="center">
            <v-dialog v-model="trimestreDialog" persistent max-width="390">
              <v-card>
                <v-card-title class="headline">Selecione o Trimestre</v-card-title>
                <v-col cols="12" md="12">
                  <v-select v-model="trimestre" item-value="idTrimestre" item-text="descricao" :items="trimestres"
                    :disabled="isUpdating" filled color="blue-grey lighten-2" label="Trimestre" return-object></v-select>
                </v-col>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click="trimestreDialog = false">Cancelar</v-btn>
                  <v-btn color="green darken-1" text :disabled="!trimestre" @click="trimestreEscolhido()">Concordar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-row>
        </div>
      </v-toolbar>
    </template>
    <template v-slot:item.action="{ item }">
      <v-icon class="mr-2" @click=" OpenDialogTrimestre(item)"  color="primary">list</v-icon>

    </template>
    <template v-slot:no-data>
      no data
    </template>
  </v-data-table>
</template>
<script>
import axios from '../../plugins/axios'
// import jsreport from 'jsreport-browser-client-dist/jsreport'
const ls = require('local-storage')
// const fs = require('fs')
// const request = require('request')
import Swal from 'sweetalert2'
const help = require('../../../Helpers/Helpers')
export default {
  data: () => ({
    componente1: 0,
    componente2: 0,
    componente3: 0,
    columnscurso: 2,
    readImage: ls.get('urlReport') + `readfile/`,
    option: {
      'format': 'A3',
      'orientation': 'landscape',
      paginationOffset: 2,
      'header': {
        'height': '10mm',
        'contents': ''
      },
      'footer': {
        'height': '5mm'
      }
    },
    trimestreDialog: false,
    trimestre: 0,
    trimestres: [{
      idTrimestre: 1,
      descricao: '1º Trimestre',
      trimestre: 'Iº Trimestre'
    },
    {
      idTrimestre: 2,
      descricao: '2º Trimestre',
      trimestre: 'IIº Trimestre'
    },
    {
      idTrimestre: 3,
      descricao: '3º Trimestre',
      trimestre: 'IIIº Trimestre'
    }
    ],
    isUpdating: false,
    url: ``,
    text: '',
    flag_curso: '',
    formValid: true,
    alunosTurma: [],
    flag_periodo: '',
    flag_sala: '',
    flag_class: '',
    sala: '',
    search: '',
    quant: 0,
    cursos: [],
    html: ``,
    disciplinas: [],
    notas: [],
    isLoading: false,
    turmas: [],
    turma: {},
    dialog: false,
    relatorio: [],
    headers: [
      {
        text: 'descricao',
        align: 'left',
        sortable: false,
        value: 'turmadescricao'
      },
      { text: 'Periodo', value: 'periodo' },
      { text: 'Curso', value: 'curso' },
      { text: 'Numero de Alunos', value: 'quantalunos' },
      { text: 'Modificado', value: 'data_2' },
      { text: 'Acção', value: 'action', sortable: false }
    ]
  }),

  computed: {
    licencaExpirada() {
      return ls.get('licencaExpirada')
    },
    idclasse() {
      return this.$store.state.idclasse
    },
    classeTur() {
      return this.$store.state.classeTur
    },
    instituicaodescricao() {
      return ls.get('instituicaodescricao')
    },

    instituicaoId() {
      return ls.get('i_id')
    }
  },

  watch: {
    dialog(val) {
      val || this.close()
    }
  },

  created() {
    // check if classe has been selected otherwise send back to painel to select
    this.initializeturmasAll()
    this.carregarConfiguracoesReports()
    this.carregarRelatorio()
  },

  methods: {
    async carregarRelatorio() {
            try {
                this.relatorio = await axios.get('/obterRelatorioByDescricao/pt').then(res => res.data)      
                if(!this.relatorio.length)  Swal.fire({ icon: 'error', title: '', text: 'Pauta Trimestral não configurada' })        
            } catch (error) {
                Swal.fire({ icon: 'error', title: '', text: 'Ocorreu um erro ao carregar o relatório' })
            }
    },
    OpenDialogTrimestre(dadosTurma) {
      if(this.licencaExpirada) {
        Swal.fire('Informação', 'A sua licença de utilização encontra-se expirada! Por favor, entre em contato com o administrador do sistema!', 'info');
      } else {
        this.trimestreDialog = true
        this.turma = dadosTurma
      }
    },


    descricaoEscola() {

      return (this.instituicaoId === 1) ? 'INSTITUTO TÉCNICO DE SAÚDE DE LUANDA' : this.instituicaodescricao.toUpperCase()
    },

    getClasseDescricao(idclasse) {

      switch (idclasse) {
        case 1:
          return '10ª Classe'
        case 2:
          return '11ª Classe'
        case 3:
          return '12ª Classe'
        case 4:
          return '13ª Classe'

        default:
          break;
      }


    },


    trimestreEscolhido() {
      this.trimestreDialog = false
      this.componente1 = 0
      this.componente2 = 0
      this.componente3 = 0
      this.columnscurso = 2
      if (this.trimestre.idTrimestre === 1) this.carregarNotasPrimeiroTrimestre()
      else
        if (this.trimestre.idTrimestre === 2) this.carregarNotasSegundoTrimestre()
      else if (this.trimestre.idTrimestre === 3) this.carregarNotasterceiroTrimestre()
       
    },

    async carregarNotasPrimeiroTrimestre() {
      this.isLoading = true
      const valor = {
        turma: this.turma.pkTurma,
        ano: this.turma.idAno_Academico
      }
      let camposPauta = {}

      try {
        this.disciplinas = await axios
          .post('/discipautageral', valor)
          .then(res => res.data)
        if (this.disciplinas.length > 0) {
          this.disciplinas = this.disciplinas[0]
          /**Obtendo a quantidade de disciplinas em cada componente */
          for (let index = 0; index < this.disciplinas.length; index++) {
            const element = this.disciplinas[index];
          if(element.componente == 1) this.componente1 ++
          else  if(element.componente == 2) this.componente2 ++
          else  if(element.componente == 3) this.componente3 ++
          }
       
        if (this.disciplinas.length === 4) {
          camposPauta = {
            turma: this.disciplinas[0].pkTurma,
            ano: this.disciplinas[0].anoLectivo,
            d0: this.disciplinas[0].iddisciplina,
            d1: this.disciplinas[1].iddisciplina,
            d2: this.disciplinas[2].iddisciplina,
            d3: this.disciplinas[3].iddisciplina,
            quant: 4
          }
        } else
          if (this.disciplinas.length === 8) {
            camposPauta = {
              turma: this.disciplinas[0].pkTurma,
              ano: this.disciplinas[0].anoLectivo,
              d0: this.disciplinas[0].iddisciplina,
              d1: this.disciplinas[1].iddisciplina,
              d2: this.disciplinas[2].iddisciplina,
              d3: this.disciplinas[3].iddisciplina,
              d4: this.disciplinas[4].iddisciplina,
              d5: this.disciplinas[5].iddisciplina,
              d6: this.disciplinas[6].iddisciplina,
              d7: this.disciplinas[7].iddisciplina,
              quant: 8
            }
          } else
            if (this.disciplinas.length === 9) {
              camposPauta = {
                turma: this.disciplinas[0].pkTurma,
                ano: this.disciplinas[0].anoLectivo,
                d0: this.disciplinas[0].iddisciplina,
                d1: this.disciplinas[1].iddisciplina,
                d2: this.disciplinas[2].iddisciplina,
                d3: this.disciplinas[3].iddisciplina,
                d4: this.disciplinas[4].iddisciplina,
                d5: this.disciplinas[5].iddisciplina,
                d6: this.disciplinas[6].iddisciplina,
                d7: this.disciplinas[7].iddisciplina,
                d8: this.disciplinas[8].iddisciplina,
                quant: 9
              }
            } else
              if (this.disciplinas.length === 10) {
                camposPauta = {
                  turma: this.disciplinas[0].pkTurma,
                  ano: this.disciplinas[0].anoLectivo,
                  d0: this.disciplinas[0].iddisciplina,
                  d1: this.disciplinas[1].iddisciplina,
                  d2: this.disciplinas[2].iddisciplina,
                  d3: this.disciplinas[3].iddisciplina,
                  d4: this.disciplinas[4].iddisciplina,
                  d5: this.disciplinas[5].iddisciplina,
                  d6: this.disciplinas[6].iddisciplina,
                  d7: this.disciplinas[7].iddisciplina,
                  d8: this.disciplinas[8].iddisciplina,
                  d9: this.disciplinas[9].iddisciplina,
                  quant: 10
                }
              } else
                if (this.disciplinas.length === 11) {
                  camposPauta = {
                    turma: this.disciplinas[0].pkTurma,
                    ano: this.disciplinas[0].anoLectivo,
                    d0: this.disciplinas[0].iddisciplina,
                    d1: this.disciplinas[1].iddisciplina,
                    d2: this.disciplinas[2].iddisciplina,
                    d3: this.disciplinas[3].iddisciplina,
                    d4: this.disciplinas[4].iddisciplina,
                    d5: this.disciplinas[5].iddisciplina,
                    d6: this.disciplinas[6].iddisciplina,
                    d7: this.disciplinas[7].iddisciplina,
                    d8: this.disciplinas[8].iddisciplina,
                    d9: this.disciplinas[9].iddisciplina,
                    d10: this.disciplinas[10].iddisciplina,
                    quant: 11
                  }
                } else
                  if (this.disciplinas.length === 12) {
                    camposPauta = {
                      turma: this.disciplinas[0].pkTurma,
                      ano: this.disciplinas[0].anoLectivo,
                      d0: this.disciplinas[0].iddisciplina,
                      d1: this.disciplinas[1].iddisciplina,
                      d2: this.disciplinas[2].iddisciplina,
                      d3: this.disciplinas[3].iddisciplina,
                      d4: this.disciplinas[4].iddisciplina,
                      d5: this.disciplinas[5].iddisciplina,
                      d6: this.disciplinas[6].iddisciplina,
                      d7: this.disciplinas[7].iddisciplina,
                      d8: this.disciplinas[8].iddisciplina,
                      d9: this.disciplinas[9].iddisciplina,
                      d10: this.disciplinas[10].iddisciplina,
                      d11: this.disciplinas[11].iddisciplina,
                      quant: 12
                    }
                  }
                  else
                  if (this.disciplinas.length === 13) {
                    camposPauta = {
                      turma: this.disciplinas[0].pkTurma,
                      ano: this.disciplinas[0].anoLectivo,
                      d0: this.disciplinas[0].iddisciplina,
                      d1: this.disciplinas[1].iddisciplina,
                      d2: this.disciplinas[2].iddisciplina,
                      d3: this.disciplinas[3].iddisciplina,
                      d4: this.disciplinas[4].iddisciplina,
                      d5: this.disciplinas[5].iddisciplina,
                      d6: this.disciplinas[6].iddisciplina,
                      d7: this.disciplinas[7].iddisciplina,
                      d8: this.disciplinas[8].iddisciplina,
                      d9: this.disciplinas[9].iddisciplina,
                      d10: this.disciplinas[10].iddisciplina,
                      d11: this.disciplinas[11].iddisciplina,
                      d12: this.disciplinas[12].iddisciplina,
                      quant: 13
                    }
                  }
                  else
                  if (this.disciplinas.length === 14) {
                    camposPauta = {
                      turma: this.disciplinas[0].pkTurma,
                      ano: this.disciplinas[0].anoLectivo,
                      d0: this.disciplinas[0].iddisciplina,
                      d1: this.disciplinas[1].iddisciplina,
                      d2: this.disciplinas[2].iddisciplina,
                      d3: this.disciplinas[3].iddisciplina,
                      d4: this.disciplinas[4].iddisciplina,
                      d5: this.disciplinas[5].iddisciplina,
                      d6: this.disciplinas[6].iddisciplina,
                      d7: this.disciplinas[7].iddisciplina,
                      d8: this.disciplinas[8].iddisciplina,
                      d9: this.disciplinas[9].iddisciplina,
                      d10: this.disciplinas[10].iddisciplina,
                      d11: this.disciplinas[11].iddisciplina,
                      d12: this.disciplinas[12].iddisciplina,
                      d13: this.disciplinas[13].iddisciplina,
                      quant: 14
                    }
                  }
        this.notas = await axios
          .post('/pautaPrimeiroTrimestre', camposPauta)
          .then(res => res.data)
          this.columnscurso += ((this.componente1 * 5) + (this.componente2 * 5) + (this.componente3 * 5))
          this.componente1 = (this.componente1 * 5).toString()
          this.componente2 = (this.componente2 * 5).toString()
          this.componente3 = (this.componente3 * 5).toString()
        if (this.disciplinas.length === 8) { this.comporHtmlPauta8(this.disciplinas, this.notas) } else
          if (this.disciplinas.length === 9) { this.comporHtmlPauta9(this.disciplinas, this.notas) } else
            if (this.disciplinas.length === 10) { this.comporHtmlPauta10(this.disciplinas, this.notas) } else
              if (this.disciplinas.length === 11) { this.comporHtmlPauta11(this.disciplinas, this.notas) } else
                if (this.disciplinas.length === 12) { this.comporHtmlPauta12(this.disciplinas, this.notas) } else
                if (this.disciplinas.length === 13) { this.comporHtmlPauta13(this.disciplinas, this.notas) } else
                if (this.disciplinas.length === 14) { this.comporHtmlPauta14(this.disciplinas, this.notas) }
        }
      } catch (error) {
        this.isLoading = false
        Swal.fire({ icon: 'error', title: '', text: 'Ocorreu um erro ao carregar Pauta Iº Trimestre' })
      }
    },
    async carregarNotasSegundoTrimestre() {
      this.isLoading = true
      const valor = {
        turma: this.turma.pkTurma,
        ano: this.turma.idAno_Academico
      }
      let camposPauta = {}
      
      try {
        this.disciplinas = await axios
          .post('/discipautageral', valor)
          .then(res => res.data)
        if (this.disciplinas.length > 0){
          this.disciplinas = this.disciplinas[0]

          /**Obtendo a quantidade de disciplinas em cada componente */
          for (let index = 0; index < this.disciplinas.length; index++) {
            const element = this.disciplinas[index];
          if(element.componente == 1) this.componente1 ++
          else  if(element.componente == 2) this.componente2 ++
          else  if(element.componente == 3) this.componente3 ++
          }
        if (this.disciplinas.length === 4) {
          camposPauta = {
            turma: this.disciplinas[0].pkTurma,
            ano: this.disciplinas[0].anoLectivo,
            d0: this.disciplinas[0].iddisciplina,
            d1: this.disciplinas[1].iddisciplina,
            d2: this.disciplinas[2].iddisciplina,
            d3: this.disciplinas[3].iddisciplina,
            quant: 4
          }          
        } else
          if (this.disciplinas.length === 8) {
            camposPauta = {
              turma: this.disciplinas[0].pkTurma,
              ano: this.disciplinas[0].anoLectivo,
              d0: this.disciplinas[0].iddisciplina,
              d1: this.disciplinas[1].iddisciplina,
              d2: this.disciplinas[2].iddisciplina,
              d3: this.disciplinas[3].iddisciplina,
              d4: this.disciplinas[4].iddisciplina,
              d5: this.disciplinas[5].iddisciplina,
              d6: this.disciplinas[6].iddisciplina,
              d7: this.disciplinas[7].iddisciplina,
              quant: 8
            }
          } else
            if (this.disciplinas.length === 9) {
              camposPauta = {
                turma: this.disciplinas[0].pkTurma,
                ano: this.disciplinas[0].anoLectivo,
                d0: this.disciplinas[0].iddisciplina,
                d1: this.disciplinas[1].iddisciplina,
                d2: this.disciplinas[2].iddisciplina,
                d3: this.disciplinas[3].iddisciplina,
                d4: this.disciplinas[4].iddisciplina,
                d5: this.disciplinas[5].iddisciplina,
                d6: this.disciplinas[6].iddisciplina,
                d7: this.disciplinas[7].iddisciplina,
                d8: this.disciplinas[8].iddisciplina,
                quant: 9
              }
            } else
              if (this.disciplinas.length === 10) {
                camposPauta = {
                  turma: this.disciplinas[0].pkTurma,
                  ano: this.disciplinas[0].anoLectivo,
                  d0: this.disciplinas[0].iddisciplina,
                  d1: this.disciplinas[1].iddisciplina,
                  d2: this.disciplinas[2].iddisciplina,
                  d3: this.disciplinas[3].iddisciplina,
                  d4: this.disciplinas[4].iddisciplina,
                  d5: this.disciplinas[5].iddisciplina,
                  d6: this.disciplinas[6].iddisciplina,
                  d7: this.disciplinas[7].iddisciplina,
                  d8: this.disciplinas[8].iddisciplina,
                  d9: this.disciplinas[9].iddisciplina,
                  quant: 10
                }
              } else
                if (this.disciplinas.length === 11) {
                  camposPauta = {
                    turma: this.disciplinas[0].pkTurma,
                    ano: this.disciplinas[0].anoLectivo,
                    d0: this.disciplinas[0].iddisciplina,
                    d1: this.disciplinas[1].iddisciplina,
                    d2: this.disciplinas[2].iddisciplina,
                    d3: this.disciplinas[3].iddisciplina,
                    d4: this.disciplinas[4].iddisciplina,
                    d5: this.disciplinas[5].iddisciplina,
                    d6: this.disciplinas[6].iddisciplina,
                    d7: this.disciplinas[7].iddisciplina,
                    d8: this.disciplinas[8].iddisciplina,
                    d9: this.disciplinas[9].iddisciplina,
                    d10: this.disciplinas[10].iddisciplina,
                    quant: 11
                  }
                } else
                  if (this.disciplinas.length === 12) {
                    camposPauta = {
                      turma: this.disciplinas[0].pkTurma,
                      ano: this.disciplinas[0].anoLectivo,
                      d0: this.disciplinas[0].iddisciplina,
                      d1: this.disciplinas[1].iddisciplina,
                      d2: this.disciplinas[2].iddisciplina,
                      d3: this.disciplinas[3].iddisciplina,
                      d4: this.disciplinas[4].iddisciplina,
                      d5: this.disciplinas[5].iddisciplina,
                      d6: this.disciplinas[6].iddisciplina,
                      d7: this.disciplinas[7].iddisciplina,
                      d8: this.disciplinas[8].iddisciplina,
                      d9: this.disciplinas[9].iddisciplina,
                      d10: this.disciplinas[10].iddisciplina,
                      d11: this.disciplinas[11].iddisciplina,
                      quant: 12
                    }

                  }else
                  if (this.disciplinas.length === 13) {
                    camposPauta = {
                      turma: this.disciplinas[0].pkTurma,
                      ano: this.disciplinas[0].anoLectivo,
                      d0: this.disciplinas[0].iddisciplina,
                      d1: this.disciplinas[1].iddisciplina,
                      d2: this.disciplinas[2].iddisciplina,
                      d3: this.disciplinas[3].iddisciplina,
                      d4: this.disciplinas[4].iddisciplina,
                      d5: this.disciplinas[5].iddisciplina,
                      d6: this.disciplinas[6].iddisciplina,
                      d7: this.disciplinas[7].iddisciplina,
                      d8: this.disciplinas[8].iddisciplina,
                      d9: this.disciplinas[9].iddisciplina,
                      d10: this.disciplinas[10].iddisciplina,
                      d11: this.disciplinas[11].iddisciplina,
                      d12: this.disciplinas[12].iddisciplina,
                      quant: 13
                    }

                  }else
                  if (this.disciplinas.length === 14) {
                    camposPauta = {
                      turma: this.disciplinas[0].pkTurma,
                      ano: this.disciplinas[0].anoLectivo,
                      d0: this.disciplinas[0].iddisciplina,
                      d1: this.disciplinas[1].iddisciplina,
                      d2: this.disciplinas[2].iddisciplina,
                      d3: this.disciplinas[3].iddisciplina,
                      d4: this.disciplinas[4].iddisciplina,
                      d5: this.disciplinas[5].iddisciplina,
                      d6: this.disciplinas[6].iddisciplina,
                      d7: this.disciplinas[7].iddisciplina,
                      d8: this.disciplinas[8].iddisciplina,
                      d9: this.disciplinas[9].iddisciplina,
                      d10: this.disciplinas[10].iddisciplina,
                      d11: this.disciplinas[11].iddisciplina,
                      d12: this.disciplinas[12].iddisciplina,
                      d13: this.disciplinas[13].iddisciplina,
                      quant: 14
                    }

                  }
        this.notas = await axios
          .post('/pautaTrimestral2Trimestre', camposPauta)
          .then(res => res.data)
          this.columnscurso += ((this.componente1 * 5) + (this.componente2 * 5) + (this.componente3 * 5))
          this.componente1 = (this.componente1 * 5).toString()
          this.componente2 = (this.componente2 * 5).toString()
          this.componente3 = (this.componente3 * 5).toString()
        if (this.disciplinas.length === 8) { this.comporHtmlPauta8(this.disciplinas, this.notas) } else
          if (this.disciplinas.length === 9) { this.comporHtmlPauta9(this.disciplinas, this.notas) } else
            if (this.disciplinas.length === 10) { this.comporHtmlPauta10(this.disciplinas, this.notas) } else
              if (this.disciplinas.length === 11) { this.comporHtmlPauta11(this.disciplinas, this.notas) } else
                if (this.disciplinas.length === 12) { this.comporHtmlPauta12(this.disciplinas, this.notas) } else
                if (this.disciplinas.length === 13) { this.comporHtmlPauta13(this.disciplinas, this.notas) } else
                if (this.disciplinas.length === 14) { this.comporHtmlPauta14(this.disciplinas, this.notas) } 
          }
      } catch (error) {
        this.isLoading = false
        Swal.fire({ icon: 'error', title: '', text: 'Ocorreu um erro ao carregar Pauta IIº Trimestre' })
      }
    },


    async carregarNotasterceiroTrimestre() {
      
      this.isLoading = true
      const valor = {
        turma: this.turma.pkTurma,
        ano: this.turma.idAno_Academico
      }
      let camposPauta = {}
      
      try {
        this.disciplinas = await axios
          .post('/discipautageral', valor)
          .then(res => res.data)
        if (this.disciplinas.length > 0){
          this.disciplinas = this.disciplinas[0]

          /**Obtendo a quantidade de disciplinas em cada componente */
          for (let index = 0; index < this.disciplinas.length; index++) {
            const element = this.disciplinas[index];
          if(element.componente == 1) this.componente1 ++
          else  if(element.componente == 2) this.componente2 ++
          else  if(element.componente == 3) this.componente3 ++
          }
        if (this.disciplinas.length === 4) {
          camposPauta = {
            turma: this.disciplinas[0].pkTurma,
            ano: this.disciplinas[0].anoLectivo,
            d0: this.disciplinas[0].iddisciplina,
            d1: this.disciplinas[1].iddisciplina,
            d2: this.disciplinas[2].iddisciplina,
            d3: this.disciplinas[3].iddisciplina,
            quant: 4
          }          
        } else
          if (this.disciplinas.length === 8) {
            camposPauta = {
              turma: this.disciplinas[0].pkTurma,
              ano: this.disciplinas[0].anoLectivo,
              d0: this.disciplinas[0].iddisciplina,
              d1: this.disciplinas[1].iddisciplina,
              d2: this.disciplinas[2].iddisciplina,
              d3: this.disciplinas[3].iddisciplina,
              d4: this.disciplinas[4].iddisciplina,
              d5: this.disciplinas[5].iddisciplina,
              d6: this.disciplinas[6].iddisciplina,
              d7: this.disciplinas[7].iddisciplina,
              quant: 8
            }
          } else
            if (this.disciplinas.length === 9) {
              camposPauta = {
                turma: this.disciplinas[0].pkTurma,
                ano: this.disciplinas[0].anoLectivo,
                d0: this.disciplinas[0].iddisciplina,
                d1: this.disciplinas[1].iddisciplina,
                d2: this.disciplinas[2].iddisciplina,
                d3: this.disciplinas[3].iddisciplina,
                d4: this.disciplinas[4].iddisciplina,
                d5: this.disciplinas[5].iddisciplina,
                d6: this.disciplinas[6].iddisciplina,
                d7: this.disciplinas[7].iddisciplina,
                d8: this.disciplinas[8].iddisciplina,
                quant: 9
              }
            } else
              if (this.disciplinas.length === 10) {
                camposPauta = {
                  turma: this.disciplinas[0].pkTurma,
                  ano: this.disciplinas[0].anoLectivo,
                  d0: this.disciplinas[0].iddisciplina,
                  d1: this.disciplinas[1].iddisciplina,
                  d2: this.disciplinas[2].iddisciplina,
                  d3: this.disciplinas[3].iddisciplina,
                  d4: this.disciplinas[4].iddisciplina,
                  d5: this.disciplinas[5].iddisciplina,
                  d6: this.disciplinas[6].iddisciplina,
                  d7: this.disciplinas[7].iddisciplina,
                  d8: this.disciplinas[8].iddisciplina,
                  d9: this.disciplinas[9].iddisciplina,
                  quant: 10
                }
              } else
                if (this.disciplinas.length === 11) {
                  camposPauta = {
                    turma: this.disciplinas[0].pkTurma,
                    ano: this.disciplinas[0].anoLectivo,
                    d0: this.disciplinas[0].iddisciplina,
                    d1: this.disciplinas[1].iddisciplina,
                    d2: this.disciplinas[2].iddisciplina,
                    d3: this.disciplinas[3].iddisciplina,
                    d4: this.disciplinas[4].iddisciplina,
                    d5: this.disciplinas[5].iddisciplina,
                    d6: this.disciplinas[6].iddisciplina,
                    d7: this.disciplinas[7].iddisciplina,
                    d8: this.disciplinas[8].iddisciplina,
                    d9: this.disciplinas[9].iddisciplina,
                    d10: this.disciplinas[10].iddisciplina,
                    quant: 11
                  }
                } else
                  if (this.disciplinas.length === 12) {
                    camposPauta = {
                      turma: this.disciplinas[0].pkTurma,
                      ano: this.disciplinas[0].anoLectivo,
                      d0: this.disciplinas[0].iddisciplina,
                      d1: this.disciplinas[1].iddisciplina,
                      d2: this.disciplinas[2].iddisciplina,
                      d3: this.disciplinas[3].iddisciplina,
                      d4: this.disciplinas[4].iddisciplina,
                      d5: this.disciplinas[5].iddisciplina,
                      d6: this.disciplinas[6].iddisciplina,
                      d7: this.disciplinas[7].iddisciplina,
                      d8: this.disciplinas[8].iddisciplina,
                      d9: this.disciplinas[9].iddisciplina,
                      d10: this.disciplinas[10].iddisciplina,
                      d11: this.disciplinas[11].iddisciplina,
                      quant: 12
                    }

                  }else
                  if (this.disciplinas.length === 13) {
                    camposPauta = {
                      turma: this.disciplinas[0].pkTurma,
                      ano: this.disciplinas[0].anoLectivo,
                      d0: this.disciplinas[0].iddisciplina,
                      d1: this.disciplinas[1].iddisciplina,
                      d2: this.disciplinas[2].iddisciplina,
                      d3: this.disciplinas[3].iddisciplina,
                      d4: this.disciplinas[4].iddisciplina,
                      d5: this.disciplinas[5].iddisciplina,
                      d6: this.disciplinas[6].iddisciplina,
                      d7: this.disciplinas[7].iddisciplina,
                      d8: this.disciplinas[8].iddisciplina,
                      d9: this.disciplinas[9].iddisciplina,
                      d10: this.disciplinas[10].iddisciplina,
                      d11: this.disciplinas[11].iddisciplina,
                      d12: this.disciplinas[12].iddisciplina,
                      quant: 13
                    }

                  }else
                  if (this.disciplinas.length === 14) {
                    camposPauta = {
                      turma: this.disciplinas[0].pkTurma,
                      ano: this.disciplinas[0].anoLectivo,
                      d0: this.disciplinas[0].iddisciplina,
                      d1: this.disciplinas[1].iddisciplina,
                      d2: this.disciplinas[2].iddisciplina,
                      d3: this.disciplinas[3].iddisciplina,
                      d4: this.disciplinas[4].iddisciplina,
                      d5: this.disciplinas[5].iddisciplina,
                      d6: this.disciplinas[6].iddisciplina,
                      d7: this.disciplinas[7].iddisciplina,
                      d8: this.disciplinas[8].iddisciplina,
                      d9: this.disciplinas[9].iddisciplina,
                      d10: this.disciplinas[10].iddisciplina,
                      d11: this.disciplinas[11].iddisciplina,
                      d12: this.disciplinas[12].iddisciplina,
                      d13: this.disciplinas[13].iddisciplina,
                      quant: 14
                    }

                  }
        this.notas = await axios
          .post('/pautaTrimestral3Trimestre', camposPauta)
          .then(res => res.data)
          this.columnscurso += ((this.componente1 * 5) + (this.componente2 * 5) + (this.componente3 * 5))
          this.componente1 = (this.componente1 * 5).toString()
          this.componente2 = (this.componente2 * 5).toString()
          this.componente3 = (this.componente3 * 5).toString()
        if (this.disciplinas.length === 8) { this.comporHtmlPauta8(this.disciplinas, this.notas) } else
          if (this.disciplinas.length === 9) { this.comporHtmlPauta9(this.disciplinas, this.notas) } else
            if (this.disciplinas.length === 10) { this.comporHtmlPauta10(this.disciplinas, this.notas) } else
              if (this.disciplinas.length === 11) { this.comporHtmlPauta11(this.disciplinas, this.notas) } else
                if (this.disciplinas.length === 12) { this.comporHtmlPauta12(this.disciplinas, this.notas) } else
                if (this.disciplinas.length === 13) { this.comporHtmlPauta13(this.disciplinas, this.notas) } else
                if (this.disciplinas.length === 14) { this.comporHtmlPauta14(this.disciplinas, this.notas) } 
          }
      } catch (error) {
        this.isLoading = false
        Swal.fire({ icon: 'error', title: '', text: 'Ocorreu um erro ao carregar Pauta IIº Trimestre' })
      }
    },
    async initializeturmasAll() {
      try {
        this.isLoading = true
        this.turmas = await axios
          .get('/turmaFindAll-Anolectivo/' + this.$store.state.anolectivoSelecionado + '/' + this.$store.state.idclasse)
          .then(res => res.data)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false
        Swal.fire({ icon: 'error', title: '', text: 'Ocorreu um erro ao carregar turmas' })
      }
    },

    ListagemEstudantes(item) {
      this.$store.state.objturma = item
      this.$router.push('ListaAlunos')
    },
    zebraPauta(i) {
      if (i % 2) {
        return 'zebr'
      } else {
        return ''
      }
    },
    async pautasgerarpdf(options) {
      this.isLoading = true
      try {
        await axios({
          method: 'post',
          url: ls.get('urlReport') + 'writefile',
          data: {
            html: this.html,
            file_name: ls.get('idPessoa'),
            option: options
          }
        }).then(function (response) { })
        // Imprimir PDF
        this.isLoading = false
        this.frame()
      } catch (error) {
        this.isLoading = false
        Swal.fire({ icon: 'error', title: '', text: 'Ocorreu um erro ao gerar o PDF' })
      }
    },
    frame() {
      this.isLoading = false
      let link = ls.get('urlReport') + 'readfile/' + ls.get('idPessoa') + '.pdf'
      let frame = `<html> +
      <style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style> 
      <body>
      <iframe target="_blank" type="application/pdf" src="` + link + `"></iframe> 
      </body></html>`
      let a = window.open('about:blank', '_blank', '', true)
      a.document.write(frame)
      a.document.close()
    },

   async comporHtmlPauta8(dados, notas) {
      try {
       /**Kalawenda */
       let directorgeral = ls.get('configuracoesReport').filter(c => c.idConfiguracoes === 20)
       let instituto = ls.get('configuracoesReport').filter(c => c.idConfiguracoes === 22)
       let subdirector = ls.get('configuracoesReport').filter(c => c.idConfiguracoes === 2)
      /** */
       let pautaTrimestralConfiguracoes = this.configuracoesReport.filter(c => c.obs === 'pauta')
       let disciplinasiter = ''
       let avaliacoesiter = ''
 
       let iteralunos = ``
       this.html = this.relatorio[0].documento
       this.html = this.html.replace(/{{instituicaodescricao}}/g, ls.get('i_id') === 144 ? instituto[0].valor : ls.get('instituicaodescricao').toUpperCase())
       this.html = this.html.replace(/{{insignia}}/g, ls.get('insignia'))
       this.html = this.html.replace(/{{anolectivo}}/g, this.$store.state.novadescricaoSelecionado)
       this.html = this.html.replace(/{{curso}}/g, dados[0].curso)
       this.html = this.html.replace(/{{turma}}/g, dados[0].descricao)
       this.html = this.html.replace(/{{classe}}/g, this.getClasseDescricao(this.idclasse))
       this.html = this.html.replace(/{{periodo}}/g, dados[0].periodo)
       this.html = this.html.replace(/{{dataactual}}/g, help.presente_data())
       this.html = this.html.replace(/{{trimestre}}/g, this.trimestre.trimestre)
       this.html = this.html.replace(/{{assinatura}}/g, pautaTrimestralConfiguracoes[0].valor)
       this.html = this.html.replace(/{{assinatura1}}/g, pautaTrimestralConfiguracoes[1].valor)
       this.html = this.html.replace(/{{assinatura2}}/g, pautaTrimestralConfiguracoes[2].valor)
       this.html = this.html.replace(/{{lengthcomponente1}}/g, this.componente1)
       this.html = this.html.replace(/{{lengthcomponente2}}/g, this.componente2)
       this.html = this.html.replace(/{{lengthcomponente3}}/g, this.componente3)
       this.html = this.html.replace(/{{columnscurso}}/g, this.columnscurso.toString())

       if(this.componente1 == 0){
        this.html = this.html.replace(/{{c1}}/g, '<!--')
        this.html = this.html.replace(/{{c1fim}}/g, '-->')
       } else {
        this.html = this.html.replace(/{{c1}}/g, '')
        this.html = this.html.replace(/{{c1fim}}/g, '')
       }
       if(this.componente2 == 0){
        this.html = this.html.replace(/{{c2}}/g, '<!--')
        this.html = this.html.replace(/{{c2fim}}/g, '-->')
       } else {
        this.html = this.html.replace(/{{c2}}/g, '')
        this.html = this.html.replace(/{{c2fim}}/g, '')
       }
       if(this.componente3 == 0){
        this.html = this.html.replace(/{{c3}}/g, '<!--')
        this.html = this.html.replace(/{{c3fim}}/g, '-->')
       } else {
        this.html = this.html.replace(/{{c3}}/g, '')
        this.html = this.html.replace(/{{c3fim}}/g, '')
       }
       /**Kalawenda */
       this.html = this.html.replace(/{{subdirector}}/g, ls.get('i_id') === 144 ? subdirector[0].valor : '')
       this.html = this.html.replace(/{{directorgeral}}/g, ls.get('i_id') === 144 ? directorgeral[0].valor : '')
this.html = this.html.replace(/{{homologacao}}/g, ls.get('i_id')  !== 144 ? `Homologado pelo (a) Director (a) do (a) Instituto Técnico de Saúde do Kalawenda` : '')
   /** */
       for (let indice = 0; indice < dados.length; indice++) {
         const element = dados[indice];
         iteralunos += this.relatorio[0].documentoiteracao4
         iteralunos = iteralunos.replace(/{{mac}}/g, '{{t' + indice + '_notaMac' + '}}')
         iteralunos = iteralunos.replace(/{{nota1}}/g, '{{t' + indice + '_nota1' + '}}')
         iteralunos = iteralunos.replace(/{{nota2}}/g, '{{t' + indice + '_nota2' + '}}')
         iteralunos = iteralunos.replace(/{{md}}/g, '{{t' + indice + '_md' + '}}')
         iteralunos = iteralunos.replace(/{{colornota}}/g, '{{co_' + indice + '}}')     
         avaliacoesiter += this.relatorio[0].documentoiteracao2
         disciplinasiter += this.relatorio[0].documentoiteracao1        
         disciplinasiter = disciplinasiter.replace(/{{disciplina}}/g, element.disciplina)       
       }
       let iter1 = ''
       for (let j = 0; j < notas.length; j++) {
         const element = notas[j];
         iter1 += this.relatorio[0].documentoiteracao3
         iter1 = iter1.replace(/{{outrascolunas}}/g, iteralunos)
         iter1 = iter1.replace(/{{zebra}}/g, this.zebraPauta(j)) 
         iter1 = iter1.replace(/{{indice}}/g, j+1) 
         iter1 = iter1.replace(/{{nome}}/g, element.nome) 
         
         iter1 = iter1.replace(/{{t0_notaMac}}/g, this.isNull(element.t0_notaMac)) 
         iter1 = iter1.replace(/{{t0_nota1}}/g, this.isNull(element.t0_nota1)) 
         iter1 = iter1.replace(/{{t0_nota2}}/g, this.isNull(element.t0_nota2)) 
         iter1 = iter1.replace(/{{t0_md}}/g, this.isNull(element.t0_md)) 
         iter1 = iter1.replace(/{{co_0}}/g, this.isNull(element.co_0))

         iter1 = iter1.replace(/{{t1_notaMac}}/g, this.isNull(element.t1_notaMac)) 
         iter1 = iter1.replace(/{{t1_nota1}}/g, this.isNull(element.t1_nota1))
         iter1 = iter1.replace(/{{t1_nota2}}/g, this.isNull(element.t1_nota2)) 
         iter1 = iter1.replace(/{{t1_md}}/g, this.isNull(element.t1_md))
         iter1 = iter1.replace(/{{co_1}}/g, this.isNull(element.co_1))

         iter1 = iter1.replace(/{{t2_notaMac}}/g, this.isNull(element.t2_notaMac)) 
         iter1 = iter1.replace(/{{t2_nota1}}/g, this.isNull(element.t2_nota1)) 
         iter1 = iter1.replace(/{{t2_nota2}}/g, this.isNull(element.t2_nota2))
         iter1 = iter1.replace(/{{t2_md}}/g, this.isNull(element.t2_md))
         iter1 = iter1.replace(/{{co_2}}/g, this.isNull(element.co_2))

         iter1 = iter1.replace(/{{t3_notaMac}}/g, this.isNull(element.t3_notaMac)) 
         iter1 = iter1.replace(/{{t3_nota1}}/g, this.isNull(element.t3_nota1))
         iter1 = iter1.replace(/{{t3_nota2}}/g, this.isNull(element.t3_nota2)) 
         iter1 = iter1.replace(/{{t3_md}}/g, this.isNull(element.t3_md))
         iter1 = iter1.replace(/{{co_3}}/g, this.isNull(element.co_3))
 
         iter1 = iter1.replace(/{{t4_notaMac}}/g, this.isNull(element.t4_notaMac)) 
         iter1 = iter1.replace(/{{t4_nota1}}/g, this.isNull(element.t4_nota1))
         iter1 = iter1.replace(/{{t4_nota2}}/g, this.isNull(element.t4_nota2))
         iter1 = iter1.replace(/{{t4_md}}/g, this.isNull(element.t4_md))
         iter1 = iter1.replace(/{{co_4}}/g, this.isNull(element.co_4))

         iter1 = iter1.replace(/{{t5_notaMac}}/g, this.isNull(element.t5_notaMac)) 
         iter1 = iter1.replace(/{{t5_nota1}}/g, this.isNull(element.t5_nota1)) 
         iter1 = iter1.replace(/{{t5_nota2}}/g, this.isNull(element.t5_nota2)) 
         iter1 = iter1.replace(/{{t5_md}}/g, this.isNull(element.t5_md))
         iter1 = iter1.replace(/{{co_5}}/g, this.isNull(element.co_5))
 
         iter1 = iter1.replace(/{{t6_notaMac}}/g, this.isNull(element.t6_notaMac))
         iter1 = iter1.replace(/{{t6_nota1}}/g, this.isNull(element.t6_nota1)) 
         iter1 = iter1.replace(/{{t6_nota2}}/g, this.isNull(element.t6_nota2)) 
         iter1 = iter1.replace(/{{t6_md}}/g, this.isNull(element.t6_md))
         iter1 = iter1.replace(/{{co_6}}/g, this.isNull(element.co_6))
 
         iter1 = iter1.replace(/{{t7_notaMac}}/g, this.isNull(element.t7_notaMac))
         iter1 = iter1.replace(/{{t7_nota1}}/g, this.isNull(element.t7_nota1)) 
         iter1 = iter1.replace(/{{t7_nota2}}/g, this.isNull(element.t7_nota2)) 
         iter1 = iter1.replace(/{{t7_md}}/g, this.isNull(element.t7_md)) 
         iter1 = iter1.replace(/{{co_7}}/g, this.isNull(element.co_7))
 
       }
       this.html = this.html.replace(/{{disciplinas}}/g, disciplinasiter)
       this.html = this.html.replace(/{{avaliacoes}}/g, avaliacoesiter)
       this.html = this.html.replace(/{{dados}}/g, iter1)
       let options = {
         'format': 'A3',
         'orientation': 'landscape',
         'border': {
           'right': '10mm',
           'bottom': '5mm',
           'left': '10mm'
 
         },
         'header': {
           'height': '8mm'
         },
         'footer': {
           'height': '5mm'
         }
       }
       this.pautasgerarpdf(options)
       } catch (error) {
         Swal.fire({ icon: 'error', title: '', text: 'Ocorreu um erro ao compor a pauta' })
       }
    },
   async comporHtmlPauta9(dados, notas) {
    try {
       /**Kalawenda */
       let directorgeral = ls.get('configuracoesReport').filter(c => c.idConfiguracoes === 20)
       let instituto = ls.get('configuracoesReport').filter(c => c.idConfiguracoes === 22)
       let subdirector = ls.get('configuracoesReport').filter(c => c.idConfiguracoes === 2)
      /** */
       let pautaTrimestralConfiguracoes = this.configuracoesReport.filter(c => c.obs === 'pauta')
       let disciplinasiter = ''
       let avaliacoesiter = ''
 
       let iteralunos = ``
       this.html = this.relatorio[0].documento
       this.html = this.html.replace(/{{instituicaodescricao}}/g, ls.get('i_id') === 144 ? instituto[0].valor : ls.get('instituicaodescricao').toUpperCase())
       this.html = this.html.replace(/{{insignia}}/g, ls.get('insignia'))
       this.html = this.html.replace(/{{anolectivo}}/g, this.$store.state.novadescricaoSelecionado)
       this.html = this.html.replace(/{{curso}}/g, dados[0].curso)
       this.html = this.html.replace(/{{turma}}/g, dados[0].descricao)
       this.html = this.html.replace(/{{classe}}/g, this.getClasseDescricao(this.idclasse))
       this.html = this.html.replace(/{{periodo}}/g, dados[0].periodo)
       this.html = this.html.replace(/{{dataactual}}/g, help.presente_data())
       this.html = this.html.replace(/{{trimestre}}/g, this.trimestre.trimestre)
       this.html = this.html.replace(/{{assinatura}}/g, pautaTrimestralConfiguracoes[0].valor)
       this.html = this.html.replace(/{{assinatura1}}/g, pautaTrimestralConfiguracoes[1].valor)
       this.html = this.html.replace(/{{assinatura2}}/g, pautaTrimestralConfiguracoes[2].valor)
       this.html = this.html.replace(/{{lengthcomponente1}}/g, this.componente1)
       this.html = this.html.replace(/{{lengthcomponente2}}/g, this.componente2)
       this.html = this.html.replace(/{{lengthcomponente3}}/g, this.componente3)
       this.html = this.html.replace(/{{columnscurso}}/g, this.columnscurso.toString())

       if(this.componente1 == 0){
        this.html = this.html.replace(/{{c1}}/g, '<!--')
        this.html = this.html.replace(/{{c1fim}}/g, '-->')
       } else {
        this.html = this.html.replace(/{{c1}}/g, '')
        this.html = this.html.replace(/{{c1fim}}/g, '')
       }
       if(this.componente2 == 0){
        this.html = this.html.replace(/{{c2}}/g, '<!--')
        this.html = this.html.replace(/{{c2fim}}/g, '-->')
       } else {
        this.html = this.html.replace(/{{c2}}/g, '')
        this.html = this.html.replace(/{{c2fim}}/g, '')
       }
       if(this.componente3 == 0){
        this.html = this.html.replace(/{{c3}}/g, '<!--')
        this.html = this.html.replace(/{{c3fim}}/g, '-->')
       } else {
        this.html = this.html.replace(/{{c3}}/g, '')
        this.html = this.html.replace(/{{c3fim}}/g, '')
       }
       /**Kalawenda */
       this.html = this.html.replace(/{{subdirector}}/g, ls.get('i_id') === 144 ? subdirector[0].valor : '')
       this.html = this.html.replace(/{{directorgeral}}/g, ls.get('i_id') === 144 ? directorgeral[0].valor : '')
       this.html = this.html.replace(/{{homologacao}}/g, ls.get('i_id')  !== 144 ? `Homologado pelo (a) Director (a) do (a) Instituto Técnico de Saúde do Kalawenda` : '')
   /** */
       for (let indice = 0; indice < dados.length; indice++) {
         const element = dados[indice];
         iteralunos += this.relatorio[0].documentoiteracao4
         iteralunos = iteralunos.replace(/{{mac}}/g, '{{t' + indice + '_notaMac' + '}}')
         iteralunos = iteralunos.replace(/{{nota1}}/g, '{{t' + indice + '_nota1' + '}}')
         iteralunos = iteralunos.replace(/{{nota2}}/g, '{{t' + indice + '_nota2' + '}}')
         iteralunos = iteralunos.replace(/{{md}}/g, '{{t' + indice + '_md' + '}}')
         iteralunos = iteralunos.replace(/{{colornota}}/g, '{{co_' + indice + '}}')  
         avaliacoesiter += this.relatorio[0].documentoiteracao2
         disciplinasiter += this.relatorio[0].documentoiteracao1        
         disciplinasiter = disciplinasiter.replace(/{{disciplina}}/g, element.disciplina)       
       }
       let iter1 = ''
       for (let j = 0; j < notas.length; j++) {
         const element = notas[j];
         iter1 += this.relatorio[0].documentoiteracao3
         iter1 = iter1.replace(/{{outrascolunas}}/g, iteralunos)
         iter1 = iter1.replace(/{{zebra}}/g, this.zebraPauta(j)) 
         iter1 = iter1.replace(/{{indice}}/g, j+1) 
         iter1 = iter1.replace(/{{nome}}/g, element.nome) 
         
         iter1 = iter1.replace(/{{co_0}}/g, this.isNull(element.co_0))
         iter1 = iter1.replace(/{{co_1}}/g, this.isNull(element.co_1))
         iter1 = iter1.replace(/{{co_2}}/g, this.isNull(element.co_2))
         iter1 = iter1.replace(/{{co_3}}/g, this.isNull(element.co_3))
         iter1 = iter1.replace(/{{co_4}}/g, this.isNull(element.co_4))
         iter1 = iter1.replace(/{{co_5}}/g, this.isNull(element.co_5))
         iter1 = iter1.replace(/{{co_6}}/g, this.isNull(element.co_6))
         iter1 = iter1.replace(/{{co_7}}/g, this.isNull(element.co_7))
         iter1 = iter1.replace(/{{co_8}}/g, this.isNull(element.co_8))

         iter1 = iter1.replace(/{{t0_notaMac}}/g, this.isNull(element.t0_notaMac)) 
         iter1 = iter1.replace(/{{t0_nota1}}/g, this.isNull(element.t0_nota1)) 
         iter1 = iter1.replace(/{{t0_nota2}}/g, this.isNull(element.t0_nota2)) 
         iter1 = iter1.replace(/{{t0_md}}/g, this.isNull(element.t0_md)) 
 
         iter1 = iter1.replace(/{{t1_notaMac}}/g, this.isNull(element.t1_notaMac)) 
         iter1 = iter1.replace(/{{t1_nota1}}/g, this.isNull(element.t1_nota1))
         iter1 = iter1.replace(/{{t1_nota2}}/g, this.isNull(element.t1_nota2)) 
         iter1 = iter1.replace(/{{t1_md}}/g, this.isNull(element.t1_md))
 
         iter1 = iter1.replace(/{{t2_notaMac}}/g, this.isNull(element.t2_notaMac)) 
         iter1 = iter1.replace(/{{t2_nota1}}/g, this.isNull(element.t2_nota1)) 
         iter1 = iter1.replace(/{{t2_nota2}}/g, this.isNull(element.t2_nota2))
         iter1 = iter1.replace(/{{t2_md}}/g, this.isNull(element.t2_md))
 
         iter1 = iter1.replace(/{{t3_notaMac}}/g, this.isNull(element.t3_notaMac)) 
         iter1 = iter1.replace(/{{t3_nota1}}/g, this.isNull(element.t3_nota1))
         iter1 = iter1.replace(/{{t3_nota2}}/g, this.isNull(element.t3_nota2)) 
         iter1 = iter1.replace(/{{t3_md}}/g, this.isNull(element.t3_md))
 
         iter1 = iter1.replace(/{{t4_notaMac}}/g, this.isNull(element.t4_notaMac)) 
         iter1 = iter1.replace(/{{t4_nota1}}/g, this.isNull(element.t4_nota1))
         iter1 = iter1.replace(/{{t4_nota2}}/g, this.isNull(element.t4_nota2))
         iter1 = iter1.replace(/{{t4_md}}/g, this.isNull(element.t4_md))
 
         iter1 = iter1.replace(/{{t5_notaMac}}/g, this.isNull(element.t5_notaMac)) 
         iter1 = iter1.replace(/{{t5_nota1}}/g, this.isNull(element.t5_nota1)) 
         iter1 = iter1.replace(/{{t5_nota2}}/g, this.isNull(element.t5_nota2)) 
         iter1 = iter1.replace(/{{t5_md}}/g, this.isNull(element.t5_md))
 
         iter1 = iter1.replace(/{{t6_notaMac}}/g, this.isNull(element.t6_notaMac))
         iter1 = iter1.replace(/{{t6_nota1}}/g, this.isNull(element.t6_nota1)) 
         iter1 = iter1.replace(/{{t6_nota2}}/g, this.isNull(element.t6_nota2)) 
         iter1 = iter1.replace(/{{t6_md}}/g, this.isNull(element.t6_md))
 
         iter1 = iter1.replace(/{{t7_notaMac}}/g, this.isNull(element.t7_notaMac))
         iter1 = iter1.replace(/{{t7_nota1}}/g, this.isNull(element.t7_nota1)) 
         iter1 = iter1.replace(/{{t7_nota2}}/g, this.isNull(element.t7_nota2)) 
         iter1 = iter1.replace(/{{t7_md}}/g, this.isNull(element.t7_md)) 
 
         iter1 = iter1.replace(/{{t8_notaMac}}/g, this.isNull(element.t8_notaMac)) 
         iter1 = iter1.replace(/{{t8_nota1}}/g, this.isNull(element.t8_nota1)) 
         iter1 = iter1.replace(/{{t8_nota2}}/g, this.isNull(element.t8_nota2)) 
         iter1 = iter1.replace(/{{t8_md}}/g, this.isNull(element.t8_md)) 
 
        }
       this.html = this.html.replace(/{{disciplinas}}/g, disciplinasiter)
       this.html = this.html.replace(/{{avaliacoes}}/g, avaliacoesiter)
       this.html = this.html.replace(/{{dados}}/g, iter1)
       let options = {
         'format': 'A3',
         'orientation': 'landscape',
         'border': {
           'right': '10mm',
           'bottom': '5mm',
           'left': '10mm'
 
         },
         'header': {
           'height': '8mm'
         },
         'footer': {
           'height': '5mm'
         }
       }
       this.pautasgerarpdf(options)
       } catch (error) {
         Swal.fire({ icon: 'error', title: '', text: 'Ocorreu um erro ao compor a pauta' })
       }
    },
    async comporHtmlPauta10(dados, notas) {
      try {
       /**Kalawenda */
       let directorgeral = ls.get('configuracoesReport').filter(c => c.idConfiguracoes === 20)
       let instituto = ls.get('configuracoesReport').filter(c => c.idConfiguracoes === 22)
       let subdirector = ls.get('configuracoesReport').filter(c => c.idConfiguracoes === 2)
      /** */
       let pautaTrimestralConfiguracoes = this.configuracoesReport.filter(c => c.obs === 'pauta')
       let disciplinasiter = ''
       let avaliacoesiter = ''
 
       let iteralunos = ``
       this.html = this.relatorio[0].documento
       this.html = this.html.replace(/{{instituicaodescricao}}/g, ls.get('i_id') === 144 ? instituto[0].valor : ls.get('instituicaodescricao').toUpperCase())
       this.html = this.html.replace(/{{insignia}}/g, ls.get('insignia'))
       this.html = this.html.replace(/{{anolectivo}}/g, this.$store.state.novadescricaoSelecionado)
       this.html = this.html.replace(/{{curso}}/g, dados[0].curso)
       this.html = this.html.replace(/{{turma}}/g, dados[0].descricao)
       this.html = this.html.replace(/{{classe}}/g, this.getClasseDescricao(this.idclasse))
       this.html = this.html.replace(/{{periodo}}/g, dados[0].periodo)
       this.html = this.html.replace(/{{dataactual}}/g, help.presente_data())
       this.html = this.html.replace(/{{trimestre}}/g, this.trimestre.trimestre)
       this.html = this.html.replace(/{{assinatura}}/g, pautaTrimestralConfiguracoes[0].valor)
       this.html = this.html.replace(/{{assinatura1}}/g, pautaTrimestralConfiguracoes[1].valor)
       this.html = this.html.replace(/{{assinatura2}}/g, pautaTrimestralConfiguracoes[2].valor)
       this.html = this.html.replace(/{{lengthcomponente1}}/g, this.componente1)
       this.html = this.html.replace(/{{lengthcomponente2}}/g, this.componente2)
       this.html = this.html.replace(/{{lengthcomponente3}}/g, this.componente3)
       this.html = this.html.replace(/{{columnscurso}}/g, this.columnscurso.toString())

       if(this.componente1 == 0){
        this.html = this.html.replace(/{{c1}}/g, '<!--')
        this.html = this.html.replace(/{{c1fim}}/g, '-->')
       } else {
        this.html = this.html.replace(/{{c1}}/g, '')
        this.html = this.html.replace(/{{c1fim}}/g, '')
       }
       if(this.componente2 == 0){
        this.html = this.html.replace(/{{c2}}/g, '<!--')
        this.html = this.html.replace(/{{c2fim}}/g, '-->')
       } else {
        this.html = this.html.replace(/{{c2}}/g, '')
        this.html = this.html.replace(/{{c2fim}}/g, '')
       }
       if(this.componente3 == 0){
        this.html = this.html.replace(/{{c3}}/g, '<!--')
        this.html = this.html.replace(/{{c3fim}}/g, '-->')
       } else {
        this.html = this.html.replace(/{{c3}}/g, '')
        this.html = this.html.replace(/{{c3fim}}/g, '')
       }
       /**Kalawenda */
       this.html = this.html.replace(/{{subdirector}}/g, ls.get('i_id') === 144 ? subdirector[0].valor : '')
       this.html = this.html.replace(/{{directorgeral}}/g, ls.get('i_id') === 144 ? directorgeral[0].valor : '')
       this.html = this.html.replace(/{{homologacao}}/g, ls.get('i_id') !== 144 ? `Homologado pelo (a) Director (a) do (a) Instituto Técnico de Saúde do Kalawenda` : '')
   /** */
       for (let indice = 0; indice < dados.length; indice++) {
         const element = dados[indice];
         iteralunos += this.relatorio[0].documentoiteracao4
         iteralunos = iteralunos.replace(/{{mac}}/g, '{{t' + indice + '_notaMac' + '}}')
         iteralunos = iteralunos.replace(/{{nota1}}/g, '{{t' + indice + '_nota1' + '}}')
         iteralunos = iteralunos.replace(/{{nota2}}/g, '{{t' + indice + '_nota2' + '}}')
         iteralunos = iteralunos.replace(/{{md}}/g, '{{t' + indice + '_md' + '}}')
         iteralunos = iteralunos.replace(/{{colornota}}/g, '{{co_' + indice + '}}')  
         avaliacoesiter += this.relatorio[0].documentoiteracao2
         disciplinasiter += this.relatorio[0].documentoiteracao1        
         disciplinasiter = disciplinasiter.replace(/{{disciplina}}/g, element.disciplina)       
       }
       let iter1 = ''
       for (let j = 0; j < notas.length; j++) {
         const element = notas[j];
         iter1 += this.relatorio[0].documentoiteracao3
         iter1 = iter1.replace(/{{outrascolunas}}/g, iteralunos)
         iter1 = iter1.replace(/{{zebra}}/g, this.zebraPauta(j)) 
         iter1 = iter1.replace(/{{indice}}/g, j+1) 
         iter1 = iter1.replace(/{{nome}}/g, element.nome) 

         iter1 = iter1.replace(/{{co_0}}/g, this.isNull(element.co_0))
         iter1 = iter1.replace(/{{co_1}}/g, this.isNull(element.co_1))
         iter1 = iter1.replace(/{{co_2}}/g, this.isNull(element.co_2))
         iter1 = iter1.replace(/{{co_3}}/g, this.isNull(element.co_3))
         iter1 = iter1.replace(/{{co_4}}/g, this.isNull(element.co_4))
         iter1 = iter1.replace(/{{co_5}}/g, this.isNull(element.co_5))
         iter1 = iter1.replace(/{{co_6}}/g, this.isNull(element.co_6))
         iter1 = iter1.replace(/{{co_7}}/g, this.isNull(element.co_7))
         iter1 = iter1.replace(/{{co_8}}/g, this.isNull(element.co_8))
         iter1 = iter1.replace(/{{co_9}}/g, this.isNull(element.co_9))
         
         iter1 = iter1.replace(/{{t0_notaMac}}/g, this.isNull(element.t0_notaMac)) 
         iter1 = iter1.replace(/{{t0_nota1}}/g, this.isNull(element.t0_nota1)) 
         iter1 = iter1.replace(/{{t0_nota2}}/g, this.isNull(element.t0_nota2)) 
         iter1 = iter1.replace(/{{t0_md}}/g, this.isNull(element.t0_md)) 
 
         iter1 = iter1.replace(/{{t1_notaMac}}/g, this.isNull(element.t1_notaMac)) 
         iter1 = iter1.replace(/{{t1_nota1}}/g, this.isNull(element.t1_nota1))
         iter1 = iter1.replace(/{{t1_nota2}}/g, this.isNull(element.t1_nota2)) 
         iter1 = iter1.replace(/{{t1_md}}/g, this.isNull(element.t1_md))
 
         iter1 = iter1.replace(/{{t2_notaMac}}/g, this.isNull(element.t2_notaMac)) 
         iter1 = iter1.replace(/{{t2_nota1}}/g, this.isNull(element.t2_nota1)) 
         iter1 = iter1.replace(/{{t2_nota2}}/g, this.isNull(element.t2_nota2))
         iter1 = iter1.replace(/{{t2_md}}/g, this.isNull(element.t2_md))
 
         iter1 = iter1.replace(/{{t3_notaMac}}/g, this.isNull(element.t3_notaMac)) 
         iter1 = iter1.replace(/{{t3_nota1}}/g, this.isNull(element.t3_nota1))
         iter1 = iter1.replace(/{{t3_nota2}}/g, this.isNull(element.t3_nota2)) 
         iter1 = iter1.replace(/{{t3_md}}/g, this.isNull(element.t3_md))
 
         iter1 = iter1.replace(/{{t4_notaMac}}/g, this.isNull(element.t4_notaMac)) 
         iter1 = iter1.replace(/{{t4_nota1}}/g, this.isNull(element.t4_nota1))
         iter1 = iter1.replace(/{{t4_nota2}}/g, this.isNull(element.t4_nota2))
         iter1 = iter1.replace(/{{t4_md}}/g, this.isNull(element.t4_md))
 
         iter1 = iter1.replace(/{{t5_notaMac}}/g, this.isNull(element.t5_notaMac)) 
         iter1 = iter1.replace(/{{t5_nota1}}/g, this.isNull(element.t5_nota1)) 
         iter1 = iter1.replace(/{{t5_nota2}}/g, this.isNull(element.t5_nota2)) 
         iter1 = iter1.replace(/{{t5_md}}/g, this.isNull(element.t5_md))
 
         iter1 = iter1.replace(/{{t6_notaMac}}/g, this.isNull(element.t6_notaMac))
         iter1 = iter1.replace(/{{t6_nota1}}/g, this.isNull(element.t6_nota1)) 
         iter1 = iter1.replace(/{{t6_nota2}}/g, this.isNull(element.t6_nota2)) 
         iter1 = iter1.replace(/{{t6_md}}/g, this.isNull(element.t6_md))
 
         iter1 = iter1.replace(/{{t7_notaMac}}/g, this.isNull(element.t7_notaMac))
         iter1 = iter1.replace(/{{t7_nota1}}/g, this.isNull(element.t7_nota1)) 
         iter1 = iter1.replace(/{{t7_nota2}}/g, this.isNull(element.t7_nota2)) 
         iter1 = iter1.replace(/{{t7_md}}/g, this.isNull(element.t7_md)) 
 
         iter1 = iter1.replace(/{{t8_notaMac}}/g, this.isNull(element.t8_notaMac)) 
         iter1 = iter1.replace(/{{t8_nota1}}/g, this.isNull(element.t8_nota1)) 
         iter1 = iter1.replace(/{{t8_nota2}}/g, this.isNull(element.t8_nota2)) 
         iter1 = iter1.replace(/{{t8_md}}/g, this.isNull(element.t8_md)) 
 
         iter1 = iter1.replace(/{{t9_notaMac}}/g, this.isNull(element.t9_notaMac)) 
         iter1 = iter1.replace(/{{t9_nota1}}/g, this.isNull(element.t9_nota1))
         iter1 = iter1.replace(/{{t9_nota2}}/g, this.isNull(element.t9_nota2))
         iter1 = iter1.replace(/{{t9_md}}/g, this.isNull(element.t9_md)) 
 
         
       }
       this.html = this.html.replace(/{{disciplinas}}/g, disciplinasiter)
       this.html = this.html.replace(/{{avaliacoes}}/g, avaliacoesiter)
       this.html = this.html.replace(/{{dados}}/g, iter1)
       let options = {
         'format': 'A3',
         'orientation': 'landscape',
         'border': {
           'right': '10mm',
           'bottom': '5mm',
           'left': '10mm'
 
         },
         'header': {
           'height': '8mm'
         },
         'footer': {
           'height': '5mm'
         }
       }
       this.pautasgerarpdf(options)
       } catch (error) {
         Swal.fire({ icon: 'error', title: '', text: 'Ocorreu um erro ao compor a pauta' })
       }
    },
    comporHtmlPauta11(dados, notas) {
      try {
       /**Kalawenda */
       let directorgeral = ls.get('configuracoesReport').filter(c => c.idConfiguracoes === 20)
       let instituto = ls.get('configuracoesReport').filter(c => c.idConfiguracoes === 22)
       let subdirector = ls.get('configuracoesReport').filter(c => c.idConfiguracoes === 2)
      /** */
       let pautaTrimestralConfiguracoes = this.configuracoesReport.filter(c => c.obs === 'pauta')
       let disciplinasiter = ''
       let avaliacoesiter = ''
 
       let iteralunos = ``
       this.html = this.relatorio[0].documento
       this.html = this.html.replace(/{{instituicaodescricao}}/g, ls.get('i_id') === 144 ? instituto[0].valor : ls.get('instituicaodescricao').toUpperCase())
       this.html = this.html.replace(/{{insignia}}/g, ls.get('insignia'))
       this.html = this.html.replace(/{{anolectivo}}/g, this.$store.state.novadescricaoSelecionado)
       this.html = this.html.replace(/{{curso}}/g, dados[0].curso)
       this.html = this.html.replace(/{{turma}}/g, dados[0].descricao)
       this.html = this.html.replace(/{{classe}}/g, this.getClasseDescricao(this.idclasse))
       this.html = this.html.replace(/{{periodo}}/g, dados[0].periodo)
       this.html = this.html.replace(/{{dataactual}}/g, help.presente_data())
       this.html = this.html.replace(/{{trimestre}}/g, this.trimestre.trimestre)
       this.html = this.html.replace(/{{assinatura}}/g, pautaTrimestralConfiguracoes[0].valor)
       this.html = this.html.replace(/{{assinatura1}}/g, pautaTrimestralConfiguracoes[1].valor)
       this.html = this.html.replace(/{{assinatura2}}/g, pautaTrimestralConfiguracoes[2].valor)
       this.html = this.html.replace(/{{lengthcomponente1}}/g, this.componente1)
       this.html = this.html.replace(/{{lengthcomponente2}}/g, this.componente2)
       this.html = this.html.replace(/{{lengthcomponente3}}/g, this.componente3)
       this.html = this.html.replace(/{{columnscurso}}/g, this.columnscurso.toString())

       if(this.componente1 == 0){
        this.html = this.html.replace(/{{c1}}/g, '<!--')
        this.html = this.html.replace(/{{c1fim}}/g, '-->')
       } else {
        this.html = this.html.replace(/{{c1}}/g, '')
        this.html = this.html.replace(/{{c1fim}}/g, '')
       }
       if(this.componente2 == 0){
        this.html = this.html.replace(/{{c2}}/g, '<!--')
        this.html = this.html.replace(/{{c2fim}}/g, '-->')
       } else {
        this.html = this.html.replace(/{{c2}}/g, '')
        this.html = this.html.replace(/{{c2fim}}/g, '')
       }
       if(this.componente3 == 0){
        this.html = this.html.replace(/{{c3}}/g, '<!--')
        this.html = this.html.replace(/{{c3fim}}/g, '-->')
       } else {
        this.html = this.html.replace(/{{c3}}/g, '')
        this.html = this.html.replace(/{{c3fim}}/g, '')
       }
       /**Kalawenda */
       this.html = this.html.replace(/{{subdirector}}/g, ls.get('i_id') === 144 ? subdirector[0].valor : '')
       this.html = this.html.replace(/{{directorgeral}}/g, ls.get('i_id') === 144 ? directorgeral[0].valor : '')
this.html = this.html.replace(/{{homologacao}}/g, ls.get('i_id')  !== 144 ? `Homologado pelo (a) Director (a) do (a) Instituto Técnico de Saúde do Kalawenda` : '')
   /** */
       for (let indice = 0; indice < dados.length; indice++) {
         const element = dados[indice];
         iteralunos += this.relatorio[0].documentoiteracao4
         iteralunos = iteralunos.replace(/{{mac}}/g, '{{t' + indice + '_notaMac' + '}}')
         iteralunos = iteralunos.replace(/{{nota1}}/g, '{{t' + indice + '_nota1' + '}}')
         iteralunos = iteralunos.replace(/{{nota2}}/g, '{{t' + indice + '_nota2' + '}}')
         iteralunos = iteralunos.replace(/{{md}}/g, '{{t' + indice + '_md' + '}}')
         iteralunos = iteralunos.replace(/{{colornota}}/g, '{{co_' + indice + '}}')  
         avaliacoesiter += this.relatorio[0].documentoiteracao2
         disciplinasiter += this.relatorio[0].documentoiteracao1        
         disciplinasiter = disciplinasiter.replace(/{{disciplina}}/g, element.disciplina)       
       }
       let iter1 = ''
       for (let j = 0; j < notas.length; j++) {
         const element = notas[j];
         iter1 += this.relatorio[0].documentoiteracao3
         iter1 = iter1.replace(/{{outrascolunas}}/g, iteralunos)
         iter1 = iter1.replace(/{{zebra}}/g, this.zebraPauta(j)) 
         iter1 = iter1.replace(/{{indice}}/g, j+1) 
         iter1 = iter1.replace(/{{nome}}/g, element.nome) 
         
         iter1 = iter1.replace(/{{co_0}}/g, this.isNull(element.co_0))
         iter1 = iter1.replace(/{{co_1}}/g, this.isNull(element.co_1))
         iter1 = iter1.replace(/{{co_2}}/g, this.isNull(element.co_2))
         iter1 = iter1.replace(/{{co_3}}/g, this.isNull(element.co_3))
         iter1 = iter1.replace(/{{co_4}}/g, this.isNull(element.co_4))
         iter1 = iter1.replace(/{{co_5}}/g, this.isNull(element.co_5))
         iter1 = iter1.replace(/{{co_6}}/g, this.isNull(element.co_6))
         iter1 = iter1.replace(/{{co_7}}/g, this.isNull(element.co_7))
         iter1 = iter1.replace(/{{co_8}}/g, this.isNull(element.co_8))
         iter1 = iter1.replace(/{{co_9}}/g, this.isNull(element.co_9))
         iter1 = iter1.replace(/{{co_10}}/g, this.isNull(element.co_10))

         iter1 = iter1.replace(/{{t0_notaMac}}/g, this.isNull(element.t0_notaMac)) 
         iter1 = iter1.replace(/{{t0_nota1}}/g, this.isNull(element.t0_nota1)) 
         iter1 = iter1.replace(/{{t0_nota2}}/g, this.isNull(element.t0_nota2)) 
         iter1 = iter1.replace(/{{t0_md}}/g, this.isNull(element.t0_md)) 
 
         iter1 = iter1.replace(/{{t1_notaMac}}/g, this.isNull(element.t1_notaMac)) 
         iter1 = iter1.replace(/{{t1_nota1}}/g, this.isNull(element.t1_nota1))
         iter1 = iter1.replace(/{{t1_nota2}}/g, this.isNull(element.t1_nota2)) 
         iter1 = iter1.replace(/{{t1_md}}/g, this.isNull(element.t1_md))
 
         iter1 = iter1.replace(/{{t2_notaMac}}/g, this.isNull(element.t2_notaMac)) 
         iter1 = iter1.replace(/{{t2_nota1}}/g, this.isNull(element.t2_nota1)) 
         iter1 = iter1.replace(/{{t2_nota2}}/g, this.isNull(element.t2_nota2))
         iter1 = iter1.replace(/{{t2_md}}/g, this.isNull(element.t2_md))
 
         iter1 = iter1.replace(/{{t3_notaMac}}/g, this.isNull(element.t3_notaMac)) 
         iter1 = iter1.replace(/{{t3_nota1}}/g, this.isNull(element.t3_nota1))
         iter1 = iter1.replace(/{{t3_nota2}}/g, this.isNull(element.t3_nota2)) 
         iter1 = iter1.replace(/{{t3_md}}/g, this.isNull(element.t3_md))
 
         iter1 = iter1.replace(/{{t4_notaMac}}/g, this.isNull(element.t4_notaMac)) 
         iter1 = iter1.replace(/{{t4_nota1}}/g, this.isNull(element.t4_nota1))
         iter1 = iter1.replace(/{{t4_nota2}}/g, this.isNull(element.t4_nota2))
         iter1 = iter1.replace(/{{t4_md}}/g, this.isNull(element.t4_md))
 
         iter1 = iter1.replace(/{{t5_notaMac}}/g, this.isNull(element.t5_notaMac)) 
         iter1 = iter1.replace(/{{t5_nota1}}/g, this.isNull(element.t5_nota1)) 
         iter1 = iter1.replace(/{{t5_nota2}}/g, this.isNull(element.t5_nota2)) 
         iter1 = iter1.replace(/{{t5_md}}/g, this.isNull(element.t5_md))
 
         iter1 = iter1.replace(/{{t6_notaMac}}/g, this.isNull(element.t6_notaMac))
         iter1 = iter1.replace(/{{t6_nota1}}/g, this.isNull(element.t6_nota1)) 
         iter1 = iter1.replace(/{{t6_nota2}}/g, this.isNull(element.t6_nota2)) 
         iter1 = iter1.replace(/{{t6_md}}/g, this.isNull(element.t6_md))
 
         iter1 = iter1.replace(/{{t7_notaMac}}/g, this.isNull(element.t7_notaMac))
         iter1 = iter1.replace(/{{t7_nota1}}/g, this.isNull(element.t7_nota1)) 
         iter1 = iter1.replace(/{{t7_nota2}}/g, this.isNull(element.t7_nota2)) 
         iter1 = iter1.replace(/{{t7_md}}/g, this.isNull(element.t7_md)) 
 
         iter1 = iter1.replace(/{{t8_notaMac}}/g, this.isNull(element.t8_notaMac)) 
         iter1 = iter1.replace(/{{t8_nota1}}/g, this.isNull(element.t8_nota1)) 
         iter1 = iter1.replace(/{{t8_nota2}}/g, this.isNull(element.t8_nota2)) 
         iter1 = iter1.replace(/{{t8_md}}/g, this.isNull(element.t8_md)) 
 
         iter1 = iter1.replace(/{{t9_notaMac}}/g, this.isNull(element.t9_notaMac)) 
         iter1 = iter1.replace(/{{t9_nota1}}/g, this.isNull(element.t9_nota1))
         iter1 = iter1.replace(/{{t9_nota2}}/g, this.isNull(element.t9_nota2))
         iter1 = iter1.replace(/{{t9_md}}/g, this.isNull(element.t9_md)) 
 
         iter1 = iter1.replace(/{{t10_notaMac}}/g, this.isNull(element.t10_notaMac)) 
         iter1 = iter1.replace(/{{t10_nota1}}/g, this.isNull(element.t10_nota1))
         iter1 = iter1.replace(/{{t10_nota2}}/g, this.isNull(element.t10_nota2)) 
         iter1 = iter1.replace(/{{t10_md}}/g, this.isNull(element.t10_md))
 
       }
       this.html = this.html.replace(/{{disciplinas}}/g, disciplinasiter)
       this.html = this.html.replace(/{{avaliacoes}}/g, avaliacoesiter)
       this.html = this.html.replace(/{{dados}}/g, iter1)
       let options = {
         'format': 'A3',
         'orientation': 'landscape',
         'border': {
           'right': '10mm',
           'bottom': '5mm',
           'left': '10mm'
 
         },
         'header': {
           'height': '8mm'
         },
         'footer': {
           'height': '5mm'
         }
       }
       this.pautasgerarpdf(options)
       } catch (error) {
         Swal.fire({ icon: 'error', title: '', text: 'Ocorreu um erro ao compor a pauta' })
       }
    },
    comporHtmlPauta12(dados, notas) {
      try {
       /**Kalawenda */
       let directorgeral = ls.get('configuracoesReport').filter(c => c.idConfiguracoes === 20)[0]
       let instituto = ls.get('configuracoesReport').filter(c => c.idConfiguracoes === 22)[0]
       let subdirector = ls.get('configuracoesReport').filter(c => c.idConfiguracoes === 2)[0]
      /** */
       let pautaTrimestralConfiguracoes = this.configuracoesReport.filter(c => c.obs === 'pauta')
       let disciplinasiter = ''
       let avaliacoesiter = ''
 
       let iteralunos = ``
       this.html = this.relatorio[0].documento
       this.html = this.html.replace(/{{instituicaodescricao}}/g, ls.get('i_id') === 144 ? instituto.valor : ls.get('instituicaodescricao').toUpperCase())
       this.html = this.html.replace(/{{insignia}}/g, ls.get('insignia'))
       this.html = this.html.replace(/{{anolectivo}}/g, this.$store.state.novadescricaoSelecionado)
       this.html = this.html.replace(/{{curso}}/g, dados[0].curso)
       this.html = this.html.replace(/{{turma}}/g, dados[0].descricao)
       this.html = this.html.replace(/{{classe}}/g, this.getClasseDescricao(this.idclasse))
       this.html = this.html.replace(/{{periodo}}/g, dados[0].periodo)
       this.html = this.html.replace(/{{dataactual}}/g, help.presente_data())
       this.html = this.html.replace(/{{trimestre}}/g, this.trimestre.trimestre)
       this.html = this.html.replace(/{{assinatura}}/g, pautaTrimestralConfiguracoes[0].valor)
       this.html = this.html.replace(/{{assinatura1}}/g, pautaTrimestralConfiguracoes[1].valor)
       this.html = this.html.replace(/{{assinatura2}}/g, pautaTrimestralConfiguracoes[2].valor)
       this.html = this.html.replace(/{{lengthcomponente1}}/g, this.componente1)
       this.html = this.html.replace(/{{lengthcomponente2}}/g, this.componente2)
       this.html = this.html.replace(/{{lengthcomponente3}}/g, this.componente3)
       this.html = this.html.replace(/{{columnscurso}}/g, this.columnscurso.toString())

       if(this.componente1 == 0){
        this.html = this.html.replace(/{{c1}}/g, '<!--')
        this.html = this.html.replace(/{{c1fim}}/g, '-->')
       } else {
        this.html = this.html.replace(/{{c1}}/g, '')
        this.html = this.html.replace(/{{c1fim}}/g, '')
       }
       if(this.componente2 == 0){
        this.html = this.html.replace(/{{c2}}/g, '<!--')
        this.html = this.html.replace(/{{c2fim}}/g, '-->')
       } else {
        this.html = this.html.replace(/{{c2}}/g, '')
        this.html = this.html.replace(/{{c2fim}}/g, '')
       }
       if(this.componente3 == 0){
        this.html = this.html.replace(/{{c3}}/g, '<!--')
        this.html = this.html.replace(/{{c3fim}}/g, '-->')
       } else {
        this.html = this.html.replace(/{{c3}}/g, '')
        this.html = this.html.replace(/{{c3fim}}/g, '')
       }
       /**Kalawenda */
       this.html = this.html.replace(/{{subdirector}}/g, ls.get('i_id') === 144 ? subdirector.valor : '')
       this.html = this.html.replace(/{{directorgeral}}/g, ls.get('i_id') === 144 ? directorgeral.valor : '')
   /** */
       for (let indice = 0; indice < dados.length; indice++) {
         const element = dados[indice];
         iteralunos += this.relatorio[0].documentoiteracao4
         iteralunos = iteralunos.replace(/{{mac}}/g, '{{t' + indice + '_notaMac' + '}}')
         iteralunos = iteralunos.replace(/{{nota1}}/g, '{{t' + indice + '_nota1' + '}}')
         iteralunos = iteralunos.replace(/{{nota2}}/g, '{{t' + indice + '_nota2' + '}}')
         iteralunos = iteralunos.replace(/{{md}}/g, '{{t' + indice + '_md' + '}}')
         iteralunos = iteralunos.replace(/{{colornota}}/g, '{{co_' + indice + '}}')  
         avaliacoesiter += this.relatorio[0].documentoiteracao2
         disciplinasiter += this.relatorio[0].documentoiteracao1        
         disciplinasiter = disciplinasiter.replace(/{{disciplina}}/g, element.disciplina)       
       }
       let iter1 = ''
       for (let j = 0; j < notas.length; j++) {
         const element = notas[j];
         iter1 += this.relatorio[0].documentoiteracao3
         iter1 = iter1.replace(/{{outrascolunas}}/g, iteralunos)
         iter1 = iter1.replace(/{{zebra}}/g, this.zebraPauta(j)) 
         iter1 = iter1.replace(/{{indice}}/g, j+1) 
         iter1 = iter1.replace(/{{nome}}/g, element.nome) 
         
         iter1 = iter1.replace(/{{co_0}}/g, this.isNull(element.co_0))
         iter1 = iter1.replace(/{{co_1}}/g, this.isNull(element.co_1))
         iter1 = iter1.replace(/{{co_2}}/g, this.isNull(element.co_2))
         iter1 = iter1.replace(/{{co_3}}/g, this.isNull(element.co_3))
         iter1 = iter1.replace(/{{co_4}}/g, this.isNull(element.co_4))
         iter1 = iter1.replace(/{{co_5}}/g, this.isNull(element.co_5))
         iter1 = iter1.replace(/{{co_6}}/g, this.isNull(element.co_6))
         iter1 = iter1.replace(/{{co_7}}/g, this.isNull(element.co_7))
         iter1 = iter1.replace(/{{co_8}}/g, this.isNull(element.co_8))
         iter1 = iter1.replace(/{{co_9}}/g, this.isNull(element.co_9))
         iter1 = iter1.replace(/{{co_10}}/g, this.isNull(element.co_10))
         iter1 = iter1.replace(/{{co_11}}/g, this.isNull(element.co_11))

         iter1 = iter1.replace(/{{t0_notaMac}}/g, this.isNull(element.t0_notaMac)) 
         iter1 = iter1.replace(/{{t0_nota1}}/g, this.isNull(element.t0_nota1)) 
         iter1 = iter1.replace(/{{t0_nota2}}/g, this.isNull(element.t0_nota2)) 
         iter1 = iter1.replace(/{{t0_md}}/g, this.isNull(element.t0_md)) 
 
         iter1 = iter1.replace(/{{t1_notaMac}}/g, this.isNull(element.t1_notaMac)) 
         iter1 = iter1.replace(/{{t1_nota1}}/g, this.isNull(element.t1_nota1))
         iter1 = iter1.replace(/{{t1_nota2}}/g, this.isNull(element.t1_nota2)) 
         iter1 = iter1.replace(/{{t1_md}}/g, this.isNull(element.t1_md))
 
         iter1 = iter1.replace(/{{t2_notaMac}}/g, this.isNull(element.t2_notaMac)) 
         iter1 = iter1.replace(/{{t2_nota1}}/g, this.isNull(element.t2_nota1)) 
         iter1 = iter1.replace(/{{t2_nota2}}/g, this.isNull(element.t2_nota2))
         iter1 = iter1.replace(/{{t2_md}}/g, this.isNull(element.t2_md))
 
         iter1 = iter1.replace(/{{t3_notaMac}}/g, this.isNull(element.t3_notaMac)) 
         iter1 = iter1.replace(/{{t3_nota1}}/g, this.isNull(element.t3_nota1))
         iter1 = iter1.replace(/{{t3_nota2}}/g, this.isNull(element.t3_nota2)) 
         iter1 = iter1.replace(/{{t3_md}}/g, this.isNull(element.t3_md))
 
         iter1 = iter1.replace(/{{t4_notaMac}}/g, this.isNull(element.t4_notaMac)) 
         iter1 = iter1.replace(/{{t4_nota1}}/g, this.isNull(element.t4_nota1))
         iter1 = iter1.replace(/{{t4_nota2}}/g, this.isNull(element.t4_nota2))
         iter1 = iter1.replace(/{{t4_md}}/g, this.isNull(element.t4_md))
 
         iter1 = iter1.replace(/{{t5_notaMac}}/g, this.isNull(element.t5_notaMac)) 
         iter1 = iter1.replace(/{{t5_nota1}}/g, this.isNull(element.t5_nota1)) 
         iter1 = iter1.replace(/{{t5_nota2}}/g, this.isNull(element.t5_nota2)) 
         iter1 = iter1.replace(/{{t5_md}}/g, this.isNull(element.t5_md))
 
         iter1 = iter1.replace(/{{t6_notaMac}}/g, this.isNull(element.t6_notaMac))
         iter1 = iter1.replace(/{{t6_nota1}}/g, this.isNull(element.t6_nota1)) 
         iter1 = iter1.replace(/{{t6_nota2}}/g, this.isNull(element.t6_nota2)) 
         iter1 = iter1.replace(/{{t6_md}}/g, this.isNull(element.t6_md))
 
         iter1 = iter1.replace(/{{t7_notaMac}}/g, this.isNull(element.t7_notaMac))
         iter1 = iter1.replace(/{{t7_nota1}}/g, this.isNull(element.t7_nota1)) 
         iter1 = iter1.replace(/{{t7_nota2}}/g, this.isNull(element.t7_nota2)) 
         iter1 = iter1.replace(/{{t7_md}}/g, this.isNull(element.t7_md)) 
 
         iter1 = iter1.replace(/{{t8_notaMac}}/g, this.isNull(element.t8_notaMac)) 
         iter1 = iter1.replace(/{{t8_nota1}}/g, this.isNull(element.t8_nota1)) 
         iter1 = iter1.replace(/{{t8_nota2}}/g, this.isNull(element.t8_nota2)) 
         iter1 = iter1.replace(/{{t8_md}}/g, this.isNull(element.t8_md)) 
 
         iter1 = iter1.replace(/{{t9_notaMac}}/g, this.isNull(element.t9_notaMac)) 
         iter1 = iter1.replace(/{{t9_nota1}}/g, this.isNull(element.t9_nota1))
         iter1 = iter1.replace(/{{t9_nota2}}/g, this.isNull(element.t9_nota2))
         iter1 = iter1.replace(/{{t9_md}}/g, this.isNull(element.t9_md)) 
 
         iter1 = iter1.replace(/{{t10_notaMac}}/g, this.isNull(element.t10_notaMac)) 
         iter1 = iter1.replace(/{{t10_nota1}}/g, this.isNull(element.t10_nota1))
         iter1 = iter1.replace(/{{t10_nota2}}/g, this.isNull(element.t10_nota2)) 
         iter1 = iter1.replace(/{{t10_md}}/g, this.isNull(element.t10_md))
 
         iter1 = iter1.replace(/{{t11_notaMac}}/g, this.isNull(element.t11_notaMac))
         iter1 = iter1.replace(/{{t11_nota1}}/g, this.isNull(element.t11_nota1)) 
         iter1 = iter1.replace(/{{t11_nota2}}/g, this.isNull(element.t11_nota2))
         iter1 = iter1.replace(/{{t11_md}}/g, this.isNull(element.t11_md))
 
       }
       this.html = this.html.replace(/{{disciplinas}}/g, disciplinasiter)
       this.html = this.html.replace(/{{avaliacoes}}/g, avaliacoesiter)
       this.html = this.html.replace(/{{dados}}/g, iter1)
       let options = {
         'format': 'A3',
         'orientation': 'landscape',
         'border': {
           'right': '10mm',
           'bottom': '5mm',
           'left': '10mm'
 
         },
         'header': {
           'height': '8mm'
         },
         'footer': {
           'height': '5mm'
         }
       }
       this.pautasgerarpdf(options)
       } catch (error) {
         Swal.fire({ icon: 'error', title: '', text: 'Ocorreu um erro ao compor a pauta' })
       }
    },



   async  comporHtmlPauta13(dados, notas) {
      try {
       /**Kalawenda */
       let directorgeral = ls.get('configuracoesReport').filter(c => c.idConfiguracoes === 20)
       let instituto = ls.get('configuracoesReport').filter(c => c.idConfiguracoes === 22)
       let subdirector = ls.get('configuracoesReport').filter(c => c.idConfiguracoes === 2)
      /** */
      let pautaTrimestralConfiguracoes = this.configuracoesReport.filter(c => c.obs === 'pauta')
      let disciplinasiter = ''
      let avaliacoesiter = ''

      let iteralunos = ``
      this.html = this.relatorio[0].documento
      this.html = this.html.replace(/{{instituicaodescricao}}/g, ls.get('i_id') === 144 ? instituto[0].valor : ls.get('instituicaodescricao').toUpperCase())
      this.html = this.html.replace(/{{insignia}}/g, ls.get('insignia'))
      this.html = this.html.replace(/{{anolectivo}}/g, this.$store.state.novadescricaoSelecionado)
      this.html = this.html.replace(/{{curso}}/g, dados[0].curso)
      this.html = this.html.replace(/{{turma}}/g, dados[0].descricao)
      this.html = this.html.replace(/{{classe}}/g, this.getClasseDescricao(this.idclasse))
      this.html = this.html.replace(/{{periodo}}/g, dados[0].periodo)
      this.html = this.html.replace(/{{dataactual}}/g, help.presente_data())
      this.html = this.html.replace(/{{trimestre}}/g, this.trimestre.trimestre)
      this.html = this.html.replace(/{{assinatura}}/g, pautaTrimestralConfiguracoes[0].valor)
      this.html = this.html.replace(/{{assinatura1}}/g, pautaTrimestralConfiguracoes[1].valor)
      this.html = this.html.replace(/{{assinatura2}}/g, pautaTrimestralConfiguracoes[2].valor)
      this.html = this.html.replace(/{{lengthcomponente1}}/g, this.componente1)
       this.html = this.html.replace(/{{lengthcomponente2}}/g, this.componente2)
       this.html = this.html.replace(/{{lengthcomponente3}}/g, this.componente3)
       this.html = this.html.replace(/{{columnscurso}}/g, this.columnscurso.toString())

       if(this.componente1 == 0){
        this.html = this.html.replace(/{{c1}}/g, '<!--')
        this.html = this.html.replace(/{{c1fim}}/g, '-->')
       } else {
        this.html = this.html.replace(/{{c1}}/g, '')
        this.html = this.html.replace(/{{c1fim}}/g, '')
       }
       if(this.componente2 == 0){
        this.html = this.html.replace(/{{c2}}/g, '<!--')
        this.html = this.html.replace(/{{c2fim}}/g, '-->')
       } else {
        this.html = this.html.replace(/{{c2}}/g, '')
        this.html = this.html.replace(/{{c2fim}}/g, '')
       }
       if(this.componente3 == 0){
        this.html = this.html.replace(/{{c3}}/g, '<!--')
        this.html = this.html.replace(/{{c3fim}}/g, '-->')
       } else {
        this.html = this.html.replace(/{{c3}}/g, '')
        this.html = this.html.replace(/{{c3fim}}/g, '')
       }
      /**Kalawenda */
      this.html = this.html.replace(/{{subdirector}}/g, ls.get('i_id') === 144 ? subdirector[0].valor : '')
       this.html = this.html.replace(/{{directorgeral}}/g, ls.get('i_id') === 144 ? directorgeral[0].valor : '')
this.html = this.html.replace(/{{homologacao}}/g, ls.get('i_id')  !== 144 ? `Homologado pelo (a) Director (a) do (a) Instituto Técnico de Saúde do Kalawenda` : '')
   /** */
      for (let indice = 0; indice < dados.length; indice++) {
        const element = dados[indice];
        iteralunos += this.relatorio[0].documentoiteracao4
        iteralunos = iteralunos.replace(/{{mac}}/g, '{{t' + indice + '_notaMac' + '}}')
        iteralunos = iteralunos.replace(/{{nota1}}/g, '{{t' + indice + '_nota1' + '}}')
        iteralunos = iteralunos.replace(/{{nota2}}/g, '{{t' + indice + '_nota2' + '}}')
        iteralunos = iteralunos.replace(/{{md}}/g, '{{t' + indice + '_md' + '}}')
        iteralunos = iteralunos.replace(/{{colornota}}/g, '{{co_' + indice + '}}')  
        avaliacoesiter += this.relatorio[0].documentoiteracao2
        disciplinasiter += this.relatorio[0].documentoiteracao1        
        disciplinasiter = disciplinasiter.replace(/{{disciplina}}/g, element.disciplina)       
      }
      let iter1 = ''
      for (let j = 0; j < notas.length; j++) {
        const element = notas[j];
        iter1 += this.relatorio[0].documentoiteracao3
        iter1 = iter1.replace(/{{outrascolunas}}/g, iteralunos)
        iter1 = iter1.replace(/{{zebra}}/g, this.zebraPauta(j)) 
        iter1 = iter1.replace(/{{indice}}/g, j+1) 
        iter1 = iter1.replace(/{{nome}}/g, element.nome) 

        iter1 = iter1.replace(/{{co_0}}/g, this.isNull(element.co_0))
         iter1 = iter1.replace(/{{co_1}}/g, this.isNull(element.co_1))
         iter1 = iter1.replace(/{{co_2}}/g, this.isNull(element.co_2))
         iter1 = iter1.replace(/{{co_3}}/g, this.isNull(element.co_3))
         iter1 = iter1.replace(/{{co_4}}/g, this.isNull(element.co_4))
         iter1 = iter1.replace(/{{co_5}}/g, this.isNull(element.co_5))
         iter1 = iter1.replace(/{{co_6}}/g, this.isNull(element.co_6))
         iter1 = iter1.replace(/{{co_7}}/g, this.isNull(element.co_7))
         iter1 = iter1.replace(/{{co_8}}/g, this.isNull(element.co_8))
         iter1 = iter1.replace(/{{co_9}}/g, this.isNull(element.co_9))
         iter1 = iter1.replace(/{{co_10}}/g, this.isNull(element.co_10))
         iter1 = iter1.replace(/{{co_11}}/g, this.isNull(element.co_11))
         iter1 = iter1.replace(/{{co_12}}/g, this.isNull(element.co_12))
        
        iter1 = iter1.replace(/{{t0_notaMac}}/g, this.isNull(element.t0_notaMac)) 
        iter1 = iter1.replace(/{{t0_nota1}}/g, this.isNull(element.t0_nota1)) 
        iter1 = iter1.replace(/{{t0_nota2}}/g, this.isNull(element.t0_nota2)) 
        iter1 = iter1.replace(/{{t0_md}}/g, this.isNull(element.t0_md)) 

        iter1 = iter1.replace(/{{t1_notaMac}}/g, this.isNull(element.t1_notaMac)) 
        iter1 = iter1.replace(/{{t1_nota1}}/g, this.isNull(element.t1_nota1))
        iter1 = iter1.replace(/{{t1_nota2}}/g, this.isNull(element.t1_nota2)) 
        iter1 = iter1.replace(/{{t1_md}}/g, this.isNull(element.t1_md))

        iter1 = iter1.replace(/{{t2_notaMac}}/g, this.isNull(element.t2_notaMac)) 
        iter1 = iter1.replace(/{{t2_nota1}}/g, this.isNull(element.t2_nota1)) 
        iter1 = iter1.replace(/{{t2_nota2}}/g, this.isNull(element.t2_nota2))
        iter1 = iter1.replace(/{{t2_md}}/g, this.isNull(element.t2_md))

        iter1 = iter1.replace(/{{t3_notaMac}}/g, this.isNull(element.t3_notaMac)) 
        iter1 = iter1.replace(/{{t3_nota1}}/g, this.isNull(element.t3_nota1))
        iter1 = iter1.replace(/{{t3_nota2}}/g, this.isNull(element.t3_nota2)) 
        iter1 = iter1.replace(/{{t3_md}}/g, this.isNull(element.t3_md))

        iter1 = iter1.replace(/{{t4_notaMac}}/g, this.isNull(element.t4_notaMac)) 
        iter1 = iter1.replace(/{{t4_nota1}}/g, this.isNull(element.t4_nota1))
        iter1 = iter1.replace(/{{t4_nota2}}/g, this.isNull(element.t4_nota2))
        iter1 = iter1.replace(/{{t4_md}}/g, this.isNull(element.t4_md))

        iter1 = iter1.replace(/{{t5_notaMac}}/g, this.isNull(element.t5_notaMac)) 
        iter1 = iter1.replace(/{{t5_nota1}}/g, this.isNull(element.t5_nota1)) 
        iter1 = iter1.replace(/{{t5_nota2}}/g, this.isNull(element.t5_nota2)) 
        iter1 = iter1.replace(/{{t5_md}}/g, this.isNull(element.t5_md))

        iter1 = iter1.replace(/{{t6_notaMac}}/g, this.isNull(element.t6_notaMac))
        iter1 = iter1.replace(/{{t6_nota1}}/g, this.isNull(element.t6_nota1)) 
        iter1 = iter1.replace(/{{t6_nota2}}/g, this.isNull(element.t6_nota2)) 
        iter1 = iter1.replace(/{{t6_md}}/g, this.isNull(element.t6_md))

        iter1 = iter1.replace(/{{t7_notaMac}}/g, this.isNull(element.t7_notaMac))
        iter1 = iter1.replace(/{{t7_nota1}}/g, this.isNull(element.t7_nota1)) 
        iter1 = iter1.replace(/{{t7_nota2}}/g, this.isNull(element.t7_nota2)) 
        iter1 = iter1.replace(/{{t7_md}}/g, this.isNull(element.t7_md)) 

        iter1 = iter1.replace(/{{t8_notaMac}}/g, this.isNull(element.t8_notaMac)) 
        iter1 = iter1.replace(/{{t8_nota1}}/g, this.isNull(element.t8_nota1)) 
        iter1 = iter1.replace(/{{t8_nota2}}/g, this.isNull(element.t8_nota2)) 
        iter1 = iter1.replace(/{{t8_md}}/g, this.isNull(element.t8_md)) 

        iter1 = iter1.replace(/{{t9_notaMac}}/g, this.isNull(element.t9_notaMac)) 
        iter1 = iter1.replace(/{{t9_nota1}}/g, this.isNull(element.t9_nota1))
        iter1 = iter1.replace(/{{t9_nota2}}/g, this.isNull(element.t9_nota2))
        iter1 = iter1.replace(/{{t9_md}}/g, this.isNull(element.t9_md)) 

        iter1 = iter1.replace(/{{t10_notaMac}}/g, this.isNull(element.t10_notaMac)) 
        iter1 = iter1.replace(/{{t10_nota1}}/g, this.isNull(element.t10_nota1))
        iter1 = iter1.replace(/{{t10_nota2}}/g, this.isNull(element.t10_nota2)) 
        iter1 = iter1.replace(/{{t10_md}}/g, this.isNull(element.t10_md))

        iter1 = iter1.replace(/{{t11_notaMac}}/g, this.isNull(element.t11_notaMac))
        iter1 = iter1.replace(/{{t11_nota1}}/g, this.isNull(element.t11_nota1)) 
        iter1 = iter1.replace(/{{t11_nota2}}/g, this.isNull(element.t11_nota2))
        iter1 = iter1.replace(/{{t11_md}}/g, this.isNull(element.t11_md))

        iter1 = iter1.replace(/{{t12_notaMac}}/g, this.isNull(element.t12_notaMac))
        iter1 = iter1.replace(/{{t12_nota1}}/g, this.isNull(element.t12_nota1)) 
        iter1 = iter1.replace(/{{t12_nota2}}/g, this.isNull(element.t12_nota2))
        iter1 = iter1.replace(/{{t12_md}}/g, this.isNull(element.t12_md))
        
      }
      this.html = this.html.replace(/{{disciplinas}}/g, disciplinasiter)
      this.html = this.html.replace(/{{avaliacoes}}/g, avaliacoesiter)
      this.html = this.html.replace(/{{dados}}/g, iter1)
      let options = {
        'format': 'A3',
        'orientation': 'landscape',
        'border': {
          'right': '10mm',
          'top': '10mm',
          'bottom': '11mm',
          'left': '10mm'
        },
      }
      this.pautasgerarpdf(options)
      } catch (error) {
        Swal.fire({ icon: 'error', title: '', text: 'Ocorreu um erro ao compor a pauta' })
      }
 },



    
    async comporHtmlPauta14(dados, notas) {
      try {
       /**Kalawenda */
       let directorgeral = ls.get('configuracoesReport').filter(c => c.idConfiguracoes === 20)
       let instituto = ls.get('configuracoesReport').filter(c => c.idConfiguracoes === 22)
       let subdirector = ls.get('configuracoesReport').filter(c => c.idConfiguracoes === 2)
      /** */

       let pautaTrimestralConfiguracoes = this.configuracoesReport.filter(c => c.obs === 'pauta')
       
       let disciplinasiter = ''
       let avaliacoesiter = ''
 
       let iteralunos = ``
       this.html = this.relatorio[0].documento
       this.html = this.html.replace(/{{instituicaodescricao}}/g, ls.get('i_id') === 144 ? instituto[0].valor : ls.get('instituicaodescricao').toUpperCase())
       this.html = this.html.replace(/{{insignia}}/g, ls.get('insignia'))
       this.html = this.html.replace(/{{anolectivo}}/g, this.$store.state.novadescricaoSelecionado)
       this.html = this.html.replace(/{{curso}}/g, dados[0].curso)
       this.html = this.html.replace(/{{turma}}/g, dados[0].descricao)
       this.html = this.html.replace(/{{classe}}/g, this.getClasseDescricao(this.idclasse))
       this.html = this.html.replace(/{{periodo}}/g, dados[0].periodo)
       this.html = this.html.replace(/{{dataactual}}/g, help.presente_data())
       this.html = this.html.replace(/{{trimestre}}/g, this.trimestre.trimestre)
       this.html = this.html.replace(/{{assinatura}}/g, pautaTrimestralConfiguracoes[0].valor)
       this.html = this.html.replace(/{{assinatura1}}/g, pautaTrimestralConfiguracoes[1].valor)
       this.html = this.html.replace(/{{assinatura2}}/g, pautaTrimestralConfiguracoes[2].valor)
       
       if(this.componente1 == 0){
        this.html = this.html.replace(/{{c1}}/g, '<!--')
        this.html = this.html.replace(/{{c1fim}}/g, '-->')
       } else {
        this.html = this.html.replace(/{{c1}}/g, '')
        this.html = this.html.replace(/{{c1fim}}/g, '')
       }
       if(this.componente2 == 0){
        this.html = this.html.replace(/{{c2}}/g, '<!--')
        this.html = this.html.replace(/{{c2fim}}/g, '-->')
       } else {
        this.html = this.html.replace(/{{c2}}/g, '')
        this.html = this.html.replace(/{{c2fim}}/g, '')
       }
       if(this.componente3 == 0){
        this.html = this.html.replace(/{{c3}}/g, '<!--')
        this.html = this.html.replace(/{{c3fim}}/g, '-->')
       } else {
        this.html = this.html.replace(/{{c3}}/g, '')
        this.html = this.html.replace(/{{c3fim}}/g, '')
       }

       this.html = this.html.replace(/{{lengthcomponente1}}/g, this.componente1)
       this.html = this.html.replace(/{{lengthcomponente2}}/g, this.componente2)
       this.html = this.html.replace(/{{lengthcomponente3}}/g, this.componente3)
       this.html = this.html.replace(/{{columnscurso}}/g, this.columnscurso.toString())
/**Kalawenda */
       this.html = this.html.replace(/{{subdirector}}/g, ls.get('i_id') === 144 ? subdirector[0].valor : '')
       this.html = this.html.replace(/{{directorgeral}}/g, ls.get('i_id') === 144 ? directorgeral[0].valor : '')
       this.html = this.html.replace(/{{homologacao}}/g, ls.get('i_id')  !== 144 ? `Homologado pelo (a) Director (a) do (a) Instituto Técnico de Saúde do Kalawenda` : '')
   /** */
       for (let indice = 0; indice < dados.length; indice++) {
         const element = dados[indice];
         iteralunos += this.relatorio[0].documentoiteracao4
         iteralunos = iteralunos.replace(/{{mac}}/g, '{{t' + indice + '_notaMac' + '}}')
         iteralunos = iteralunos.replace(/{{nota1}}/g, '{{t' + indice + '_nota1' + '}}')
         iteralunos = iteralunos.replace(/{{nota2}}/g, '{{t' + indice + '_nota2' + '}}')
         iteralunos = iteralunos.replace(/{{md}}/g, '{{t' + indice + '_md' + '}}')
         iteralunos = iteralunos.replace(/{{colornota}}/g, '{{co_' + indice + '}}')  
         avaliacoesiter += this.relatorio[0].documentoiteracao2
         disciplinasiter += this.relatorio[0].documentoiteracao1        
         disciplinasiter = disciplinasiter.replace(/{{disciplina}}/g, element.disciplina)       
       }
       let iter1 = ''
       for (let j = 0; j < notas.length; j++) {
         const element = notas[j];
         iter1 += this.relatorio[0].documentoiteracao3
         iter1 = iter1.replace(/{{outrascolunas}}/g, iteralunos)
         iter1 = iter1.replace(/{{zebra}}/g, this.zebraPauta(j)) 
         iter1 = iter1.replace(/{{indice}}/g, j+1) 
         iter1 = iter1.replace(/{{nome}}/g, element.nome) 
         
         iter1 = iter1.replace(/{{co_0}}/g, this.isNull(element.co_0))
         iter1 = iter1.replace(/{{co_1}}/g, this.isNull(element.co_1))
         iter1 = iter1.replace(/{{co_2}}/g, this.isNull(element.co_2))
         iter1 = iter1.replace(/{{co_3}}/g, this.isNull(element.co_3))
         iter1 = iter1.replace(/{{co_4}}/g, this.isNull(element.co_4))
         iter1 = iter1.replace(/{{co_5}}/g, this.isNull(element.co_5))
         iter1 = iter1.replace(/{{co_6}}/g, this.isNull(element.co_6))
         iter1 = iter1.replace(/{{co_7}}/g, this.isNull(element.co_7))
         iter1 = iter1.replace(/{{co_8}}/g, this.isNull(element.co_8))
         iter1 = iter1.replace(/{{co_9}}/g, this.isNull(element.co_9))
         iter1 = iter1.replace(/{{co_10}}/g, this.isNull(element.co_10))
         iter1 = iter1.replace(/{{co_11}}/g, this.isNull(element.co_11))
         iter1 = iter1.replace(/{{co_12}}/g, this.isNull(element.co_12))
         iter1 = iter1.replace(/{{co_13}}/g, this.isNull(element.co_13))

         iter1 = iter1.replace(/{{t0_notaMac}}/g, this.isNull(element.t0_notaMac)) 
         iter1 = iter1.replace(/{{t0_nota1}}/g, this.isNull(element.t0_nota1)) 
         iter1 = iter1.replace(/{{t0_nota2}}/g, this.isNull(element.t0_nota2)) 
         iter1 = iter1.replace(/{{t0_md}}/g, this.isNull(element.t0_md)) 
 
         iter1 = iter1.replace(/{{t1_notaMac}}/g, this.isNull(element.t1_notaMac)) 
         iter1 = iter1.replace(/{{t1_nota1}}/g, this.isNull(element.t1_nota1))
         iter1 = iter1.replace(/{{t1_nota2}}/g, this.isNull(element.t1_nota2)) 
         iter1 = iter1.replace(/{{t1_md}}/g, this.isNull(element.t1_md))
 
         iter1 = iter1.replace(/{{t2_notaMac}}/g, this.isNull(element.t2_notaMac)) 
         iter1 = iter1.replace(/{{t2_nota1}}/g, this.isNull(element.t2_nota1)) 
         iter1 = iter1.replace(/{{t2_nota2}}/g, this.isNull(element.t2_nota2))
         iter1 = iter1.replace(/{{t2_md}}/g, this.isNull(element.t2_md))
 
         iter1 = iter1.replace(/{{t3_notaMac}}/g, this.isNull(element.t3_notaMac)) 
         iter1 = iter1.replace(/{{t3_nota1}}/g, this.isNull(element.t3_nota1))
         iter1 = iter1.replace(/{{t3_nota2}}/g, this.isNull(element.t3_nota2)) 
         iter1 = iter1.replace(/{{t3_md}}/g, this.isNull(element.t3_md))
 
         iter1 = iter1.replace(/{{t4_notaMac}}/g, this.isNull(element.t4_notaMac)) 
         iter1 = iter1.replace(/{{t4_nota1}}/g, this.isNull(element.t4_nota1))
         iter1 = iter1.replace(/{{t4_nota2}}/g, this.isNull(element.t4_nota2))
         iter1 = iter1.replace(/{{t4_md}}/g, this.isNull(element.t4_md))
 
         iter1 = iter1.replace(/{{t5_notaMac}}/g, this.isNull(element.t5_notaMac)) 
         iter1 = iter1.replace(/{{t5_nota1}}/g, this.isNull(element.t5_nota1)) 
         iter1 = iter1.replace(/{{t5_nota2}}/g, this.isNull(element.t5_nota2)) 
         iter1 = iter1.replace(/{{t5_md}}/g, this.isNull(element.t5_md))
 
         iter1 = iter1.replace(/{{t6_notaMac}}/g, this.isNull(element.t6_notaMac))
         iter1 = iter1.replace(/{{t6_nota1}}/g, this.isNull(element.t6_nota1)) 
         iter1 = iter1.replace(/{{t6_nota2}}/g, this.isNull(element.t6_nota2)) 
         iter1 = iter1.replace(/{{t6_md}}/g, this.isNull(element.t6_md))
 
         iter1 = iter1.replace(/{{t7_notaMac}}/g, this.isNull(element.t7_notaMac))
         iter1 = iter1.replace(/{{t7_nota1}}/g, this.isNull(element.t7_nota1)) 
         iter1 = iter1.replace(/{{t7_nota2}}/g, this.isNull(element.t7_nota2)) 
         iter1 = iter1.replace(/{{t7_md}}/g, this.isNull(element.t7_md)) 
 
         iter1 = iter1.replace(/{{t8_notaMac}}/g, this.isNull(element.t8_notaMac)) 
         iter1 = iter1.replace(/{{t8_nota1}}/g, this.isNull(element.t8_nota1)) 
         iter1 = iter1.replace(/{{t8_nota2}}/g, this.isNull(element.t8_nota2)) 
         iter1 = iter1.replace(/{{t8_md}}/g, this.isNull(element.t8_md)) 
 
         iter1 = iter1.replace(/{{t9_notaMac}}/g, this.isNull(element.t9_notaMac)) 
         iter1 = iter1.replace(/{{t9_nota1}}/g, this.isNull(element.t9_nota1))
         iter1 = iter1.replace(/{{t9_nota2}}/g, this.isNull(element.t9_nota2))
         iter1 = iter1.replace(/{{t9_md}}/g, this.isNull(element.t9_md)) 
 
         iter1 = iter1.replace(/{{t10_notaMac}}/g, this.isNull(element.t10_notaMac)) 
         iter1 = iter1.replace(/{{t10_nota1}}/g, this.isNull(element.t10_nota1))
         iter1 = iter1.replace(/{{t10_nota2}}/g, this.isNull(element.t10_nota2)) 
         iter1 = iter1.replace(/{{t10_md}}/g, this.isNull(element.t10_md))
 
         iter1 = iter1.replace(/{{t11_notaMac}}/g, this.isNull(element.t11_notaMac))
         iter1 = iter1.replace(/{{t11_nota1}}/g, this.isNull(element.t11_nota1)) 
         iter1 = iter1.replace(/{{t11_nota2}}/g, this.isNull(element.t11_nota2))
         iter1 = iter1.replace(/{{t11_md}}/g, this.isNull(element.t11_md))
 
         iter1 = iter1.replace(/{{t12_notaMac}}/g, this.isNull(element.t12_notaMac))
         iter1 = iter1.replace(/{{t12_nota1}}/g, this.isNull(element.t12_nota1)) 
         iter1 = iter1.replace(/{{t12_nota2}}/g, this.isNull(element.t12_nota2))
         iter1 = iter1.replace(/{{t12_md}}/g, this.isNull(element.t12_md))
         
         iter1 = iter1.replace(/{{t13_notaMac}}/g, this.isNull(element.t13_notaMac))
         iter1 = iter1.replace(/{{t13_nota1}}/g, this.isNull(element.t13_nota1)) 
         iter1 = iter1.replace(/{{t13_nota2}}/g, this.isNull(element.t13_nota2))
         iter1 = iter1.replace(/{{t13_md}}/g, this.isNull(element.t13_md))
       }
       this.html = this.html.replace(/{{disciplinas}}/g, disciplinasiter)
       this.html = this.html.replace(/{{avaliacoes}}/g, avaliacoesiter)
       this.html = this.html.replace(/{{dados}}/g, iter1)
       let options = {
         'format': 'A3',
         'orientation': 'landscape',
         'border': {
           'right': '10mm',
           'bottom': '5mm',
           'left': '10mm'
 
         },
         'header': {
           'height': '8mm'
         },
         'footer': {
           'height': '5mm'
         }
       }
       this.pautasgerarpdf(options)
       } catch (error) {
         Swal.fire({ icon: 'error', title: '', text: 'Ocorreu um erro ao compor a pauta' })
       }
    },


    isNull(notaPauta) {
      if (notaPauta) { return notaPauta } else return ''
    },
    async carregarConfiguracoesReports() {
      try {
        let msg = await axios
          .post('/configuracoes', { empresa: 'report_Pauta' })
          .then(res => res.data)
        if (msg.length > 0) {
          this.configuracoesReport = msg
        }
      } catch (error) {

      }
    }

  }
}
</script>
